import React, { useState, Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import { useDispatch, useSelector } from 'react-redux'
import { useStateIfMounted } from 'use-state-if-mounted'

import estilos from './AtencionAClientesFC_36Component.module.css';
import {
    actualizarFC_36Estatus,
    resetDataFC_36,
    actualizarFC_36PaginaActiva,
    agregarMapFC_36Accion,
    obtenerIdCliente,
    actualizarFC_36Solicitud,
    actualizarMapFC_36Accion,
    obtenerFC_36SolicitudDetalle, aceptarSolicitud,
    obtenerClienteDetalle, enviarCorreo,
    generarDocumentos, obtenerFolio, obtenerFC_01PorLoginMap, enviarCorreoContrato, actualizarFC_36Formulario
} from '../../../redux/DucksAtencionACliente/FC_36AtencionAClienteDucks'
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado, obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks'

import { v4 as uuidv4 } from 'uuid';
import { host } from '../../../configuraciones'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import TablaAnexosFC36 from './Anexos/AtencionAClientesTablaAnexosFC36';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import BotonDescargarArchivos from '../../App/BotonDescargarArchivos';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
const { useEffect, useRef } = React;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import TablaMediosContacto from './TablasAnexos/TablaMediosContacto';
import TablaPersonasAutorizadas from './TablasAnexos/TablaPersonasAutorizadas';
import TablaRepresentanteslegales from './TablasAnexos/TablaRepresentantesLegales';
import TablaDocumentacion from '../../App/TablaDocumentacion';
import TablaDomicilio from './TablasAnexos/TablaDomicilio'
import TablaAtencionACliente from './TablaAtencionACliente';
import TablaPredio from './TablasAnexos/TablaPredio';
import TablaVivero from './TablasAnexos/TablaVivero';
import TablaMarcas from './TablasAnexos/TablaMarcas';
import TablaMarcasBebidasConMezcal from './TablasAnexos/TablaMarcasBebidasConMezcal';
import TablaInstalaciones from './TablasAnexos/TablaInstalaciones';
import TablaResponsablesInstalaciones from './TablasAnexos/TablaResponsablesInstalaciones';
import FormularioDocumentacion from './FormularioDocumentacion';
import { crearMetricas } from '../../../redux/DuckMetricas/MetricasDuck';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
const styleParaAceptar = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    height: 290,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
const styleDevolver = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function FC_36Component(props) {

    const solicitud = useSelector(store => store.FC_36SolicitudAtencionACliente.data)
    console.log("los datos de la solicitud es ", solicitud)
    const currentUser = useSelector(store => store.Usuario.data)
    const dispatch = useDispatch()
    let fc_36Map = useSelector(store => store.FC_36SolicitudAtencionACliente.fc_36Map)
    let fc_36MediosContactoMap = useSelector(store => store.FC_36SolicitudAtencionACliente.fc_36MediosContactoMap)
    let fc_36PersonasAutorizadasMap = useSelector(store => store.FC_36SolicitudAtencionACliente.fc_36PersonasAutorizadasMap)
    let fc_36RepresentanteLegalMap = useSelector(store => store.FC_36SolicitudAtencionACliente.fc_36RepresentanteLegalMap)
    let fc_36DomicilioFiscalMap = useSelector(store => store.FC_36SolicitudAtencionACliente.fc_36DomicilioFiscalMap)
    const dataUser = useSelector(store => store.Usuario.user)
    let filtroPrediosBaja = solicitud.fc_36_anexoviveros?.filter(anexo => anexo?.baja == true)
    let filtroViveroBaja = solicitud.fc_36_anexopredio?.filter(anexo => anexo?.baja == true)

    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3])
    const modoVerDetalle = useSelector(store => store.FC_36SolicitudAtencionACliente.modoVerDetalle)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos solicitante', 'Documentación'])
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }
    const [altaRepresentante, setAltaRepresentante] = useStateIfMounted(false)
    const [altaResponsable, setAltaResponsable] = useStateIfMounted(false)
    const [altaDomicilio, setAltaDomicilio] = useStateIfMounted(false)
    const [altaMarcas, setAltaMarcas] = useStateIfMounted(false)
    const [altaMarcasBebidas, setAltaMarcasBebidas] = useStateIfMounted(false)
    const [altaResponsableInst, setAltaResponsableInst] = useStateIfMounted(false)
    const [altaPrediosViveros, setAltaViverosPredios] = useStateIfMounted(false)


    React.useEffect(() => {
        let totalDePaginas = 1
        const nuevosApartados = ['Datos generales']
        let filtroMedios = solicitud.fc_36_anexomediosdecontacto?.filter(anexo => anexo?.alta == true)

        if ((solicitud.actualizarmedioscontacto && !solicitud.cambiorazon) || (solicitud.cambiorazon && filtroMedios.length > 0)) {
            totalDePaginas++
            let nombreApartado = 'Medios de contacto'
            nuevosApartados.push(nombreApartado)
        }
        let filtroPersona = solicitud.fc_36_anexopersonasautorizadas?.filter(anexo => anexo?.alta == true)
        if ((solicitud.cambiorepresentante && !solicitud.cambiorazon) || (solicitud.cambiorazon && filtroPersona.length > 0)) {
            totalDePaginas++
            let nombreApartado = 'Persona autorizada'
            nuevosApartados.push(nombreApartado)
        }
        let filtroApoderados = solicitud.fc_36_anexoapoderadoslegales?.filter(anexo => anexo?.alta == true)
        if ((solicitud.cambioresponsable && !solicitud.cambiorazon) || (solicitud.cambiorazon && filtroApoderados.length > 0)) {
            totalDePaginas++
            let nombreApartado = 'Representante legal y/o Apoderado Legal'
            nuevosApartados.push(nombreApartado)
        }

        if (solicitud.actualizaciondomicilio || solicitud.cambiorazon) {
            totalDePaginas++
            let nombreApartado = 'Domicilio Fiscal'
            nuevosApartados.push(nombreApartado)
        }
        if ((solicitud.actualizacionprediosviveros && (solicitud.viverista || solicitud.productormaguey)) || (solicitud.actualizacioncadena && solicitud.viveristaaltabaja)
            || (solicitud.actualizacioncadena && solicitud.productormagueyaltabaja) || (solicitud.cambiorazon && (solicitud.viverista || solicitud.productormaguey))) {
            totalDePaginas++
            let nombreApartado = 'Predios/Viveros'
            nuevosApartados.push(nombreApartado)
        }
        if (solicitud.actualizarmarcas || (solicitud.actualizacioncadena && solicitud.comercializadormezcalaltabaja) ||
            (solicitud.actualizacioncadena && solicitud.comercializadorbebidasaltabaja) || (solicitud.cambiorazon && (solicitud.comercializadormezcal || solicitud.comercializadorbebidas))) {
            totalDePaginas++
            let nombreApartado = 'Marcas'
            nuevosApartados.push(nombreApartado)
        }
        if (solicitud.cambioresponsableinst) {
            totalDePaginas++
            let nombreApartado = 'Actualización Responsables de Instalaciones'
            nuevosApartados.push(nombreApartado)
        }
        let filtroInstalacion = solicitud?.fc_36anexo?.filter(anexo => anexo?.baja == true)
        let filtroInstalacionAlta = solicitud?.fc_36anexo?.filter(anexo => anexo?.alta == true)
        if ((solicitud.actualizacioncadena && (filtroInstalacion.length > 0 || filtroInstalacionAlta.length > 0)) || (solicitud.actualizacioninstalaciones && !solicitud.cambiorazon) ||
            (solicitud.cambiorazon && (solicitud.productormezcal || solicitud.envasador || solicitud.comercializadorbebidas || solicitud.comercializadormezcal))) {
            totalDePaginas++
            let nombreApartado = 'Instalaciones'
            nuevosApartados.push(nombreApartado)
        }

        let filtroDomicilios = solicitud.fc_36_anexodomiciliosfiscales?.filter(anexo => anexo?.alta == true)
        let filtroResposablesInst = solicitud.fc_36_actualizacionresponsableinstalaciones?.filter(anexo => anexo?.alta == true)
        let filtroMarcas = solicitud.fc_36_anexomarcas?.filter(anexo => anexo?.alta == true)
        let filtroMarcasBebidas = solicitud.fc_36_anexomarcasproductoconmezcal?.filter(anexo => anexo?.alta == true)
        let filtroViveros = solicitud.fc_36_anexoviveros?.filter(anexo => anexo?.alta == true)
        let filtroPredios = solicitud.fc_36_anexopredio?.filter(anexo => anexo?.alta == true)



        if (filtroPersona?.length > 0) setAltaRepresentante(true)
        if (filtroApoderados?.length > 0) setAltaResponsable(true)
        if (filtroDomicilios?.length > 0) setAltaDomicilio(true)
        if (filtroMarcas?.length > 0) setAltaMarcas(true)
        if (filtroResposablesInst?.length > 0) setAltaResponsableInst(true)
        if (filtroMarcasBebidas?.length > 0) setAltaMarcasBebidas(true)
        if (filtroViveros?.length > 0 || filtroPredios?.length > 0) setAltaViverosPredios(true)
        if ((solicitud.cambiorepresentante && filtroPersona.length > 0) ||
            (solicitud.cambioresponsable && filtroApoderados.length > 0) ||
            (solicitud.cambioresponsableinst && filtroResposablesInst.length > 0) ||
            (solicitud.actualizarmarcas && filtroMarcas.length > 0) ||
            (solicitud.actualizacioncadena && filtroMarcas.length > 0) ||
            (solicitud.actualizarmarcas && filtroMarcasBebidas.length > 0) ||
            (solicitud.actualizacioncadena && filtroMarcasBebidas.length > 0) ||
            (solicitud.actualizaciondomicilio && filtroDomicilios.length > 0) ||
            (solicitud.actualizacionprediosviveros && (filtroViveros.length > 0 || filtroPredios.length > 0))
            || (solicitud.actualizacioninstalaciones) ||
            (solicitud.actualizacioncadena && solicitud.envasadoraltabaja) ||
            (solicitud.actualizacioncadena && solicitud.productormezcalaltabaja) ||
            (solicitud.actualizacioncadena && solicitud.productormagueyaltabaja && solicitud.productormaguey) ||
            (solicitud.actualizacioncadena && solicitud.viverista && solicitud.viveristaaltabaja)) {
            totalDePaginas++
            nuevosApartados.push('Documentación')
        }

        let nuevasPaginas = []
        for (let index = 1; index <= totalDePaginas; index++) {
            nuevasPaginas.push(index)
        }
        setPaginas(nuevasPaginas)
        setNombresParaPaginas(nuevosApartados)
    }, [solicitud])

    let paginaGeneral = []

    if (!solicitud.cambiorazon) {
        if (solicitud.cambiorazon)
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Cambio de razón social', valor: solicitud.cambiorazon ? 'Si' : 'No', idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                    idfc36_solicitudactualizacionmap: fc_36Map.idfc36_solicitudactualizacionmap ? fc_36Map.idfc36_solicitudactualizacionmap : ''
                },)
        if (solicitud.actualizacioncadena) {
            let combinacion = []
            if (solicitud.viverista && solicitud.viveristaaltabaja) combinacion.push('Alta viverista')
            if ((!solicitud.viverista) && solicitud.viveristaaltabaja) combinacion.push('Baja viverista')
            if (solicitud.productormaguey && solicitud.productormagueyaltabaja) combinacion.push('Alta productor maguey')
            if ((!solicitud.productormaguey) && solicitud.productormagueyaltabaja) combinacion.push('Baja productor maguey')

            if ((solicitud.comercializadormezcal) && solicitud.comercializadormezcalaltabaja) combinacion.push('Alta comercializador de mezcal')
            if ((!solicitud.comercializadormezcal) && solicitud.comercializadormezcalaltabaja) combinacion.push('Baja comercializador de mezcal')
            if ((solicitud.comercializadorbebidas) && solicitud.comercializadorbebidasaltabaja) combinacion.push('Alta comercializador de bebidas con mezcal')
            if ((!solicitud.comercializadorbebidas) && solicitud.comercializadorbebidasaltabaja) combinacion.push('Baja comercializador de bebidas con mezcal')

            if ((solicitud.productormezcal) && solicitud.productormezcalaltabaja) combinacion.push('Alta productor de mezcal')
            if ((!solicitud.productormezcal) && solicitud.productormezcalaltabaja) combinacion.push('Baja productor de mezcal')
            if ((solicitud.envasador) && solicitud.envasadoraltabaja) combinacion.push('Alta envasador')
            if ((!solicitud.envasador) && solicitud.envasadoraltabaja) combinacion.push('Baja envasador')

            let cadenaProductivaAccion = ''
            for (const i in combinacion) {
                if (Number(i) + 1 == combinacion.length) {
                    cadenaProductivaAccion += combinacion[i]
                } else {
                    if (combinacion[i + 1] != combinacion.length) {
                        cadenaProductivaAccion += combinacion[i] + ','
                    } else {
                        cadenaProductivaAccion += ' y ' + combinacion[i]
                    }
                }
            }
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Actualización de cadena productiva', valor: cadenaProductivaAccion, idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                },)
        }
        if (solicitud.actualizaciondomicilio)
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Actualización de domicilio fiscal', valor: solicitud.actualizaciondomicilio ? 'Si' : 'No', idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                },)
        if (solicitud.cambioresponsable)
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Actualización de representante legal  y/o apoderado legal', valor: solicitud.cambioresponsable ? 'Si' : 'No', idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                },)
        if (solicitud.cambiorepresentante)
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Actualización de persona autorizada para trámite', valor: solicitud.cambiorepresentante ? 'Si' : 'No', idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                },)
        if (solicitud.actualizarmedioscontacto)
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Actualización medios de contacto', valor: solicitud.actualizarmedioscontacto ? 'Si' : 'No', idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                }
            )
        if (solicitud.cambioresponsableinst)
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Actualización de responsable de instalaciones', valor: solicitud.cambioresponsableinst ? 'Si' : 'No', idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                },
                {
                    id: uuidv4(), Campo: 'Nombre o razón social', valor: solicitud.nombrerazonsocial, idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                }
            )
        if (solicitud.actualizarmarcas)
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Actualización de marcas', valor: solicitud.actualizarmarcas ? 'Si' : 'No', idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                }
            )
        if (solicitud.actualizacionprediosviveros)
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Baja de predios/viveros', valor: solicitud.actualizacionprediosviveros ? 'Si' : 'No', idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                }
            )
        if (solicitud.actualizacioninstalaciones)
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Actualización de Instalaciones', valor: solicitud.actualizacioninstalaciones ? 'Si' : 'No', idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                }
            )

        /*if (solicitud.actualizacioncadena) {
            let cadena = []
            if (solicitud.viverista) cadena.push('Viverista')
            if (solicitud.productormaguey) cadena.push('Productor de maguey')
            if (solicitud.productormezcal) cadena.push('Productor de mezcal')
            if (solicitud.envasador) cadena.push('Envasador')
            if (solicitud.comercializadormezcal) cadena.push('Comercializador de mezcal')
            if (solicitud.comercializadorbebidas) cadena.push('Comercializador de productos con mezcal')
            let cadenaProductiva = ''
            for (const i in cadena) {
                if (cadena[i + 1] != cadena.length) {
                    cadenaProductiva = cadena[i] + ','
                } else {
                    cadenaProductiva = ' y ' + cadena[i]
                }
            }
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Cadena productiva', valor: cadenaProductiva, idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                },
            )
        }*/
    } else {
        let cadenaProductiva = ''
        const arrayCadena = []
        if (solicitud.viverista) arrayCadena.push('Viverista')
        if (solicitud.productormaguey) arrayCadena.push('Productor de maguey')
        if (solicitud.productormezcal) arrayCadena.push('Productor de mezcal')
        if (solicitud.envasador) arrayCadena.push('Envasador')
        if (solicitud.comercializadormezcal) arrayCadena.push('Comercializador de mezcal')
        if (solicitud.comercializadorbebidasconmezcal) arrayCadena.push('Comercializador de productos con mezcal')
        if (arrayCadena.length > 1) {
            for (const i in arrayCadena) {
                if (Number(i) === 0) {
                    cadenaProductiva += arrayCadena[i]
                } else if (Number(i) + Number(1) === arrayCadena.length) {
                    cadenaProductiva += ' y ' + arrayCadena[i]
                } else {
                    cadenaProductiva += ', ' + arrayCadena[i]
                }
            }
        } else {
            cadenaProductiva = arrayCadena[0]
        }
        paginaGeneral.push(
            {
                id: uuidv4(), Campo: 'Cambio de razón social', valor: solicitud.cambiorazon ? 'Si' : 'No', idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
            },
            {
                id: uuidv4(), Campo: 'Tipo de empresa', valor: solicitud.tipoempresa == 'moral' ? 'Moral' : 'Fisica', idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
            },
            {
                id: uuidv4(), Campo: 'RFC', valor: solicitud.rfc, idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
            },
            {
                id: uuidv4(), Campo: 'Nombre o razón social', valor: solicitud.actualizacionnombrerazon, idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
            },)
        if (solicitud.certificacionsi) {
            paginaGeneral.push(
                {
                    id: uuidv4(), Campo: 'Empresa certificadora', valor: solicitud.empresacertificadora, idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
                },
            )
        }
        paginaGeneral.push(
            {
                id: uuidv4(), Campo: 'Cadena productiva', valor: cadenaProductiva, idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacion : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? !fc_36Map?.tipoinstalacioncheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_36Map) && JSON.stringify([]) !== JSON.stringify(fc_36Map) ? fc_36Map?.tipoinstalacioncheck : false,
            },
        )
    }
    let [rowspaginaGeneral, setRowsPaginaGeneral] = React.useState(paginaGeneral)
    let pagina1 = []
    let paginaDoc = []
    if (solicitud.actualizaciondomicilio || solicitud.cambioresponsable || solicitud.cambiorepresentante) paginaDoc.push({ id: uuidv4(), nameDoc: 'DOCUMENTACIÓN GENERAL' })

    for (const j in solicitud.fc_36archivogeneral) {
        const nameId = solicitud.fc_36archivogeneral[j].nameid
        const { ...prop } = solicitud.fc_36archivogeneral[j]
        let nameDoc = ''
        if ((nameId).includes('DGC')) nameDoc = 'Comprobante de pago '
        if ((nameId).includes('DGAC')) nameDoc = 'Acta constitutiva notariada con Registro Público de Comercio'
        if ((nameId).includes('DGRFC')) nameDoc = 'Constancia de situación fiscal (RFC).'
        if ((nameId).includes('DGIOV')) nameDoc = 'Identificación oficial vigente del solicitante'
        if ((nameId).includes('DGRFC')) nameDoc = 'Constancia de situación fiscal (RFC).'
        let fechaInicio = moment(prop?.fechainicio).add(1, 'd').format('YYYY-MM-DD')
        let fechaTermino = moment(prop?.fechafin).add(1, 'd').format('YYYY-MM-DD')
        paginaDoc.push({
            id: uuidv4(),
            //observaciones: prop?.fc_36archivogeneral[j]?.fc_36_archivosinstalacionesmap?.[0] ? prop?.fc_36_archivosinstalaciones[j]?.fc_36_archivosinstalacionesmap[0]?.observacion : '',
            //correcto: prop?.fc_36archivogeneral[j]?.fc_36_archivosinstalacionesmap?.[0] ? !prop?.fc_36_archivosinstalaciones[j]?.fc_36_archivosinstalacionesmap[0]?.estatuscheck : false,
            //incorrecto: prop?.fc_36archivogeneral[j]?.fc_36_archivosinstalacionesmap?.[0] ? prop?.fc_36_archivosinstalaciones[j]?.fc_36_archivosinstalacionesmap[0]?.estatuscheck : false,
            fechaInicio: prop?.fechainicio ? fechaInicio : '',
            fechaTermino: prop?.fechafin ? fechaTermino : '',
            estatus: prop?.estatus ? prop?.estatus : 'Agregar',
            //idMap: prop?.fc_36_archivosinstalacionesmap[0] ? prop?.fc_36_archivosinstalacionesmap?.[0]?.idarchivosinstalacionmap : '',
            idfc_36archivogeneral: prop?.idfc_36archivogeneral,
            tabla: 'fc_36archivogeneral', nombreId: 'idfc_36archivogeneral',
            idSolicitud: prop?.idfc_36archivogeneral,
            nameid: nameId, nameDoc: nameDoc,
        })
    }




    for (const i in solicitud.fc_36_anexomediosdecontacto) {
        if ((solicitud.fc_36_anexomediosdecontacto[i].alta == false && solicitud.fc_36_anexomediosdecontacto[i].baja == true) ||
            (solicitud.fc_36_anexomediosdecontacto[i].alta == true && solicitud.fc_36_anexomediosdecontacto[i].baja == null) ||
            (solicitud.fc_36_anexomediosdecontacto[i].alta == true && solicitud.fc_36_anexomediosdecontacto[i].baja == false)/* ||
            solicitud.cambiorazon*/) {
            let filtro = fc_36MediosContactoMap?.filter(anexo => anexo?.idfc36_anexomediodecontacto === producto?.idfc36_anexomediodecontacto)
            pagina1.push(
                {
                    id: uuidv4(), idfc36_anexomediodecontacto: solicitud.fc_36_anexomediosdecontacto[i].idfc36_anexomediodecontacto,
                    idfc36_anexomediodecontactomap: solicitud.fc_36_anexomediosdecontacto?.[i]?.fc_36_anexomediosdecontactomap[0]?.idfc36_anexomediodecontactomap ? solicitud.fc_36_anexomediosdecontacto?.[i]?.fc_36_anexomediosdecontactomap[0]?.idfc36_anexomediodecontactomap : '',
                    telefono: solicitud.fc_36_anexomediosdecontacto[i].telefono,
                    correoelectronico: solicitud.fc_36_anexomediosdecontacto[i].correoelectronico,
                    relacioncontacto: solicitud.fc_36_anexomediosdecontacto[i].relacioncontacto,
                    baja: solicitud.fc_36_anexomediosdecontacto[i].baja,
                    alta: solicitud.fc_36_anexomediosdecontacto[i].alta,
                    isbaja: solicitud.fc_36_anexomediosdecontacto[i].isbaja,
                    observaciones: solicitud.fc_36_anexomediosdecontacto?.[i]?.fc_36_anexomediosdecontactomap[0] ? solicitud.fc_36_anexomediosdecontacto?.[i]?.fc_36_anexomediosdecontactomap?.[0]?.observacion : '',
                    correcto: solicitud.fc_36_anexomediosdecontacto?.[i]?.fc_36_anexomediosdecontactomap[0] ? !solicitud.fc_36_anexomediosdecontacto?.[i]?.fc_36_anexomediosdecontactomap[0]?.validacioncheck : false,
                    incorrecto: solicitud.fc_36_anexomediosdecontacto?.[i]?.fc_36_anexomediosdecontactomap[0] ? solicitud.fc_36_anexomediosdecontacto?.[i]?.fc_36_anexomediosdecontactomap[0]?.validacioncheck : false,
                }
            )
        }
    }
    let [rowspagina1, setRowsPagina1] = React.useState(pagina1)
    let pagina2 = []
    for (const i in solicitud.fc_36_anexopersonasautorizadas) {
        if ((solicitud.fc_36_anexopersonasautorizadas[i].alta == true && solicitud.fc_36_anexopersonasautorizadas[i].baja == null)) {
            paginaDoc.push({ id: uuidv4(), nameDoc: 'Documentación de persona autorizada: ' + solicitud.fc_36_anexopersonasautorizadas[i].personaautoriazadaparatramites })
        }
        if ((solicitud.fc_36_anexopersonasautorizadas[i].alta == false && solicitud.fc_36_anexopersonasautorizadas[i].baja == true) ||
            (solicitud.fc_36_anexopersonasautorizadas[i].alta == true && solicitud.fc_36_anexopersonasautorizadas[i].baja == null) ||
            (solicitud.fc_36_anexopersonasautorizadas[i].alta == true && solicitud.fc_36_anexopersonasautorizadas[i].baja == false)) {
            //let filtro = fc_36PersonasAutorizadasMap?.filter(anexo => anexo?.idfc36_anexopersonasautorizadas === producto?.idfc36_anexopersonasautorizadas)
            pagina2.push({
                id: uuidv4(), idfc36_anexopersonasautorizadas: solicitud.fc_36_anexopersonasautorizadas[i].idfc36_anexopersonasautorizadas,
                idfc36_anexopersonasautorizadasmap: solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0]?.idfc36_anexopersonasautorizadasmap ? solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0]?.idfc36_anexopersonasautorizadasmap : '',
                personaautoriazadaparatramites: solicitud.fc_36_anexopersonasautorizadas[i].personaautoriazadaparatramites,
                telefono: solicitud.fc_36_anexopersonasautorizadas[i].telefono,
                correoelectronico: solicitud.fc_36_anexopersonasautorizadas[i].correoelectronico,
                relacioncontacto: solicitud.fc_36_anexopersonasautorizadas[i].relacioncontacto,
                baja: solicitud.fc_36_anexopersonasautorizadas[i].baja,
                isbaja: solicitud.fc_36_anexopersonasautorizadas[i].isbaja,
                alta: solicitud.fc_36_anexopersonasautorizadas[i].alta,
                observaciones: solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0] ? solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0]?.observacion : '',
                correcto: solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0] ? !solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0]?.validacioncheck : false,
                incorrecto: solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0] ? solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0]?.validacioncheck : false,
            })
        } /*else {
            if (solicitud.cambiorazon) {
                pagina2.push({
                    id: uuidv4(), idfc36_anexopersonasautorizadas: solicitud.fc_36_anexopersonasautorizadas[i].idfc36_anexopersonasautorizadas,
                    idfc36_anexopersonasautorizadasmap: solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0]?.idfc36_anexopersonasautorizadasmap ? solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0]?.idfc36_anexopersonasautorizadasmap : '',
                    personaautoriazadaparatramites: solicitud.fc_36_anexopersonasautorizadas[i].personaautoriazadaparatramites,
                    telefono: solicitud.fc_36_anexopersonasautorizadas[i].telefono,
                    correoelectronico: solicitud.fc_36_anexopersonasautorizadas[i].correoelectronico,
                    relacioncontacto: solicitud.fc_36_anexopersonasautorizadas[i].relacioncontacto,
                    baja: solicitud.fc_36_anexopersonasautorizadas[i].baja,
                    isbaja: solicitud.fc_36_anexopersonasautorizadas[i].isbaja,
                    alta: solicitud.fc_36_anexopersonasautorizadas[i].alta,
                    observaciones: solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0] ? solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0]?.observacion : '',
                    correcto: solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0] ? !solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0]?.validacioncheck : false,
                    incorrecto: solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0] ? solicitud.fc_36_anexopersonasautorizadas?.[i]?.fc_36_anexopersonasautorizadasmap?.[0]?.validacioncheck : false,
                })
            }
        }*/

        //const filtroFacturaMap = filesProductosMap?.filter(anexo => anexo.idfc_41archivoproducto === filtrofactura[0].idfc_41archivoproducto)
        if (solicitud.fc_36_anexopersonasautorizadas[i].alta == true) {
            let nameid = `DGIOVAUT${solicitud.fc_36_anexopersonasautorizadas[i].idfc36_anexopersonasautorizadas}`
            const filtroIdentificacion = solicitud.fc_36_anexopersonasautorizadas[i].fc_36archivopersonasautorizadas.filter(anexo => anexo.nameid === nameid)
            let fechaInicio = moment(filtroIdentificacion?.[0]?.fechainicio).add(1, 'd').format('YYYY-MM-DD')
            let fechaTermino = moment(filtroIdentificacion?.[0]?.fechafin).add(1, 'd').format('YYYY-MM-DD')
            paginaDoc.push({
                id: uuidv4(),
                observaciones: filtroIdentificacion?.[0]?.fc_36archivopersonasautorizadasmap?.[0] ? filtroIdentificacion?.[0]?.fc_36archivopersonasautorizadasmap?.[0]?.observacion : '',
                correcto: filtroIdentificacion?.[0]?.fc_36archivopersonasautorizadasmap?.[0] ? !filtroIdentificacion?.[0]?.fc_36archivopersonasautorizadasmap?.[0]?.estatuscheck : false,
                incorrecto: filtroIdentificacion?.[0]?.fc_36archivopersonasautorizadasmap?.[0] ? filtroIdentificacion?.[0]?.fc_36archivopersonasautorizadasmap?.[0]?.estatuscheck : false,
                fechaInicio: filtroIdentificacion?.[0]?.fechainicio ? fechaInicio : '',
                fechaTermino: filtroIdentificacion?.[0]?.fechafin ? fechaTermino : '',
                estatus: filtroIdentificacion?.[0]?.estatus ? filtroIdentificacion?.[0]?.estatus : 'Agregar',
                idMap: filtroIdentificacion?.[0]?.fc_36archivopersonasautorizadasmap?.[0] ? filtroIdentificacion?.[0]?.fc_36archivopersonasautorizadasmap?.[0]?.idfc_36archivopersonasautorizadasmap : '',
                idfc_36archivopersonasautorizadas: filtroIdentificacion?.[0]?.idfc_36archivopersonasautorizadas,
                tabla: 'fc_36archivopersonasautorizadas', nombreId: 'idfc36_anexopersonasautorizadas',
                idSolicitud: filtroIdentificacion?.[0]?.idfc36_anexopersonasautorizadas,
                nameid: `DGIOVAUT${solicitud.fc_36_anexopersonasautorizadas[i].idfc36_anexopersonasautorizadas}`,
                nameDoc: 'Identificación oficial vigente de la persona autorizada ' + solicitud.fc_36_anexopersonasautorizadas[i].personaautoriazadaparatramites,
            })
        }
    }
    let [rowspagina2, setRowsPagina2] = React.useState(pagina2)
    let pagina3 = []
    for (const i in solicitud.fc_36_anexoapoderadoslegales) {
        if ((solicitud.fc_36_anexoapoderadoslegales[i].alta == true && solicitud.fc_36_anexoapoderadoslegales[i].baja == null) || solicitud.cambiorazon) {
            paginaDoc.push({
                id: uuidv4(), nameDoc: 'Documentación del ' + (solicitud.fc_36_anexoapoderadoslegales[i].pripcipal == true ? 'representante legal: ' : 'apoderado legal: ') + solicitud.fc_36_anexoapoderadoslegales[i].representantelegal
            })
        }
        if ((solicitud.fc_36_anexoapoderadoslegales[i].alta == false && solicitud.fc_36_anexoapoderadoslegales[i].baja == true) ||
            (solicitud.fc_36_anexoapoderadoslegales[i].alta == true && solicitud.fc_36_anexoapoderadoslegales[i].baja == null) ||
            (solicitud.fc_36_anexoapoderadoslegales[i].alta == true && solicitud.fc_36_anexoapoderadoslegales[i].baja == false)) {
            let filtro = fc_36RepresentanteLegalMap?.filter(anexo => anexo?.idfc36_anexoapoderadoslegales === producto?.idfc36_anexoapoderadoslegales)
            pagina3.push(
                {
                    id: uuidv4(), idfc36_anexoapoderadoslegales: solicitud.fc_36_anexoapoderadoslegales[i].idfc36_anexoapoderadoslegales,
                    idfc36_anexoapoderadoslegalesmap: solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0]?.idfc36_anexoapoderadoslegalesmap ? solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0]?.idfc36_anexoapoderadoslegalesmap : '',
                    representantelegal: solicitud.fc_36_anexoapoderadoslegales[i].representantelegal,
                    telefono: solicitud.fc_36_anexoapoderadoslegales[i].telefono,
                    correoelectronico: solicitud.fc_36_anexoapoderadoslegales[i].correoelectronico,
                    relacioncontacto: solicitud.fc_36_anexoapoderadoslegales[i].relacioncontacto,
                    baja: solicitud.fc_36_anexoapoderadoslegales[i].baja,
                    isbaja: solicitud.fc_36_anexoapoderadoslegales[i].isbaja,
                    alta: solicitud.fc_36_anexoapoderadoslegales[i].alta,
                    principal: solicitud.fc_36_anexoapoderadoslegales[i].principal,
                    observaciones: solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0] ? solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0]?.observacion : '',
                    correcto: solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0] ? !solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0]?.validacioncheck : false,
                    incorrecto: solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0] ? solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0]?.validacioncheck : false,
                }
            )
        } else {
            if (solicitud.cambiorazon) {
                pagina3.push(
                    {
                        id: uuidv4(), idfc36_anexoapoderadoslegales: solicitud.fc_36_anexoapoderadoslegales[i].idfc36_anexoapoderadoslegales,
                        idfc36_anexoapoderadoslegalesmap: solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0]?.idfc36_anexoapoderadoslegalesmap ? solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0]?.idfc36_anexoapoderadoslegalesmap : '',
                        representantelegal: solicitud.fc_36_anexoapoderadoslegales[i].representantelegal,
                        telefono: solicitud.fc_36_anexoapoderadoslegales[i].telefono,
                        correoelectronico: solicitud.fc_36_anexoapoderadoslegales[i].correoelectronico,
                        relacioncontacto: solicitud.fc_36_anexoapoderadoslegales[i].relacioncontacto,
                        baja: solicitud.fc_36_anexoapoderadoslegales[i].baja,
                        isbaja: solicitud.fc_36_anexoapoderadoslegales[i].isbaja,
                        alta: solicitud.fc_36_anexoapoderadoslegales[i].alta,
                        principal: solicitud.fc_36_anexoapoderadoslegales[i].principal,
                        observaciones: solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0] ? solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0]?.observacion : '',
                        correcto: solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0] ? !solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0]?.validacioncheck : false,
                        incorrecto: solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0] ? solicitud.fc_36_anexoapoderadoslegales?.[i]?.fc_36_anexoapoderadoslegalesmap?.[0]?.validacioncheck : false,
                    })
            }
        }

        if (solicitud.fc_36_anexoapoderadoslegales[i].alta == true && solicitud.fc_36_anexoapoderadoslegales[i].baja == null || solicitud.cambiorazon) {
            for (const j in solicitud.fc_36_anexoapoderadoslegales[i].fc_36archivoresponsablelegal) {
                const { ...prop } = solicitud.fc_36_anexoapoderadoslegales[i].fc_36archivoresponsablelegal[j]
                const nameId = prop.nameid
                let nameDoc = ''
                if ((nameId).includes('DGIOVAP')) nameDoc = 'Identificación oficial vigente'
                else if ((nameId).includes('DGPNAP')) nameDoc = 'Poder notarial o acta de asamblea'
                let fechaInicio = moment(prop?.fechainicio).add(1, 'd').format('YYYY-MM-DD')
                let fechaTermino = moment(prop?.fechafin).add(1, 'd').format('YYYY-MM-DD')
                paginaDoc.push({
                    id: uuidv4(),
                    observaciones: prop.fc_36archivoresponsablelegalmap?.[0] ? prop.fc_36archivoresponsablelegalmap?.[0]?.observacion : '',
                    correcto: prop.fc_36archivoresponsablelegalmap?.[0] ? !prop.fc_36archivoresponsablelegalmap?.[0]?.estatuscheck : false,
                    incorrecto: prop.fc_36archivoresponsablelegalmap?.[0] ? prop.fc_36archivoresponsablelegalmap?.[0]?.estatuscheck : false,
                    fechaInicio: prop?.fechainicio ? fechaInicio : '',
                    fechaTermino: prop?.fechafin ? fechaTermino : '',
                    estatus: prop?.estatus ? prop?.estatus : 'Agregar',
                    idMap: prop.fc_36archivoresponsablelegalmap?.[0] ? prop.fc_36archivoresponsablelegalmap?.[0]?.idfc_36archivoresponsablelegalmap : '',
                    idfc_36archivoresponsablelegal: prop?.idfc_36archivoresponsablelegal,
                    tabla: 'fc_36archivoresponsablelegal', nombreId: 'idfc36_anexoapoderadoslegales',
                    idSolicitud: prop?.idfc36_anexoapoderadoslegales,
                    nameid: nameId, nameDoc: nameDoc //+ ': ' + solicitud.fc_36_anexoapoderadoslegales[i].representantelegal,
                })
            }
        }
    }
    let [rowspagina3, setRowsPagina3] = React.useState(pagina3)

    let paginaDomicilio = []
    for (const i in solicitud.fc_36_anexodomiciliosfiscales) {
        if (solicitud.fc_36_anexodomiciliosfiscales[i].alta == true && solicitud.fc_36_anexodomiciliosfiscales[i].baja == null || solicitud.cambiorazon) {
            paginaDoc.push({
                id: uuidv4(), nameDoc: 'Documentación del domicilio fiscal: ' +
                    solicitud.fc_36_anexodomiciliosfiscales[i].calle + ', ' + solicitud.fc_36_anexodomiciliosfiscales[i].numerointerior + ', ' +
                    solicitud.fc_36_anexodomiciliosfiscales[i].numeroexterior + ', ' + solicitud.fc_36_anexodomiciliosfiscales[i].colonia + ', ' +
                    solicitud.fc_36_anexodomiciliosfiscales[i].localidad + ', ' + solicitud.fc_36_anexodomiciliosfiscales[i].municipio + ', ' +
                    solicitud.fc_36_anexodomiciliosfiscales[i].estado + ', ' + solicitud.fc_36_anexodomiciliosfiscales[i].codigopostal

            })
        }
        if ((solicitud.fc_36_anexodomiciliosfiscales[i].alta === false && solicitud.fc_36_anexodomiciliosfiscales[i].baja === true) ||
            (solicitud.fc_36_anexodomiciliosfiscales[i].alta === true) ||
            solicitud.cambiorazon) {
            const { ...anexo } = solicitud.fc_36_anexodomiciliosfiscales[i]
            let filtro = fc_36DomicilioFiscalMap?.filter(anexo => anexo?.idfc36_anexodomiciliosfiscales === producto?.idfc36_anexodomiciliosfiscales)
            paginaDomicilio.push(
                {
                    id: uuidv4(), idfc36_anexodomiciliosfiscales: solicitud.fc_36_anexodomiciliosfiscales[i].idfc36_anexodomiciliosfiscales,
                    idfc36_anexodomiciliosfiscalesmap: solicitud.fc_36_anexodomiciliosfiscales?.[i].fc_36_anexodomiciliosfiscalesmap?.[0] ? solicitud.fc_36_anexodomiciliosfiscales?.[i]?.fc_36_anexodomiciliosfiscalesmap?.[0].idfc36_anexodomiciliosfiscalesmap : '',
                    domicilio: anexo.calle + ', ' + anexo.numerointerior + ', ' + anexo.numeroexterior + ', ' + anexo.colonia + ', ' + anexo.localidad + ', ' +
                        anexo.municipio + ', ' + anexo.estado + ', ' + anexo.codigopostal,
                    relacioncontacto: solicitud.fc_36_anexodomiciliosfiscales[i].relacioncontacto,
                    baja: solicitud.fc_36_anexodomiciliosfiscales[i].baja,
                    isbaja: solicitud.fc_36_anexodomiciliosfiscales[i].isbaja,
                    alta: solicitud.fc_36_anexodomiciliosfiscales[i].alta,
                    domicilioprincipal: solicitud.fc_36_anexodomiciliosfiscales[i].domicilioprincipal,
                    observaciones: solicitud.fc_36_anexodomiciliosfiscales?.[i].fc_36_anexodomiciliosfiscalesmap?.[0] ? solicitud.fc_36_anexodomiciliosfiscales?.[i]?.fc_36_anexodomiciliosfiscalesmap?.[0]?.observacion : '',
                    correcto: solicitud.fc_36_anexodomiciliosfiscales?.[i].fc_36_anexodomiciliosfiscalesmap?.[0] ? !solicitud.fc_36_anexodomiciliosfiscales?.[i]?.fc_36_anexodomiciliosfiscalesmap?.[0]?.validacioncheck : false,
                    incorrecto: solicitud.fc_36_anexodomiciliosfiscales?.[i].fc_36_anexodomiciliosfiscalesmap?.[0] ? solicitud.fc_36_anexodomiciliosfiscales?.[i]?.fc_36_anexodomiciliosfiscalesmap?.[0]?.validacioncheck : false,
                }
            )
        }
        if ((solicitud.fc_36_anexodomiciliosfiscales[i].alta == true && solicitud.fc_36_anexodomiciliosfiscales[i].baja == null) || solicitud.cambiorazon) {
            for (const j in solicitud.fc_36_anexodomiciliosfiscales[i].fc_36archivodomiciliosficales) {
                const { ...prop } = solicitud.fc_36_anexodomiciliosfiscales[i].fc_36archivodomiciliosficales[j]
                const nameId = prop.nameid
                let nameDoc = ''
                if ((nameId).includes('DGCSF')) nameDoc = 'Constancia de situación fiscal'
                else if ((nameId).includes('DGCD')) nameDoc = 'Comprobante de domicilio'
                let fechaInicio = moment(prop?.fechainicio).add(1, 'd').format('YYYY-MM-DD')
                let fechaTermino = moment(prop?.fechafin).add(1, 'd').format('YYYY-MM-DD')
                paginaDoc.push({
                    id: uuidv4(),
                    observaciones: prop?.fc_36archivodomiciliosficalesmap?.[0] ? prop?.fc_36archivodomiciliosficalesmap?.[0]?.observacion : '',
                    correcto: prop?.fc_36archivodomiciliosficalesmap?.[0] ? !prop?.fc_36archivodomiciliosficalesmap?.[0]?.estatuscheck : false,
                    incorrecto: prop?.fc_36archivodomiciliosficalesmap?.[0] ? prop?.fc_36archivodomiciliosficalesmap?.[0]?.estatuscheck : false,
                    fechaInicio: prop?.fechainicio ? fechaInicio : '',
                    fechaTermino: prop?.fechafin ? fechaTermino : '',
                    estatus: prop?.estatus ? prop?.estatus : 'Agregar',
                    idMap: prop?.fc_36archivodomiciliosficalesmap?.[0] ? prop?.fc_36archivodomiciliosficalesmap?.[0]?.idfc_36archivodomiciliosfiscalesmap : '',
                    idfc_36archivodomiciliosfiscales: prop?.idfc_36archivodomiciliosfiscales,
                    tabla: 'fc_36archivodomiciliosficales', nombreId: 'idfc36_anexodomiciliosfiscales',
                    idSolicitud: prop?.idfc36_anexodomiciliosfiscales,
                    nameid: nameId, nameDoc: nameDoc
                })
            }
        }
    }

    let [rowspaginaDomiclio, setRowsPaginaDomicilio] = React.useState(paginaDomicilio)

    let vivero = []
    for (const index in solicitud.fc_36_anexoviveros) {
        if (solicitud.fc_36_anexoviveros[index].alta == true && solicitud.fc_36_anexoviveros[index].baja == null || solicitud.cambiorazon) {
            paginaDoc.push({ id: uuidv4(), nameDoc: 'Documentación del vivero: ' + solicitud.fc_36_anexoviveros[index].nombreparaje })
        }
        const { ...prop } = solicitud.fc_36_anexoviveros[index]
        let primeraLetra = prop.nombreparaje.charAt(0).toUpperCase()
        let cadena = primeraLetra + prop.nombreparaje.substring(1, prop.nombreparaje.length)
        let cultivado = 'No'
        let semicultivado = 'No'
        let silvestre = 'No'
        if (prop.cultivado) cultivado = 'Si'
        if (prop.semicultivado) semicultivado = 'Si'
        if (prop.silvestre) silvestre = 'Si'
        if (prop.alta || prop.baja || solicitud.cambiorazon) {
            vivero.push({
                id: uuidv4(), idfc_36_anexoviveros: prop.idfc_36_anexoviveros,
                Campo: `Domicilio`, domicilio: prop.calle + ';' + prop.numeroexterior + ';' + prop.codigopostal + ';' + prop.localidad
                    + ';' + prop.municipio + ';' + prop.distrito + ';' + prop.estado,
                cultivado: cultivado, semicultivado: semicultivado, silvestre: silvestre,
                nombreparaje: prop.nombreparaje,
                baja: prop.baja,
                alta: prop.alta,
                isbaja: prop.isbaja,
                observaciones: prop.fc_36_anexoviverosmap?.[0] ? prop.fc_36_anexoviverosmap?.[0]?.observacion : '',
                correcto: prop.fc_36_anexoviverosmap?.[0] ? !prop.fc_36_anexoviverosmap?.[0]?.validacioncheck : false,
                incorrecto: prop.fc_36_anexoviverosmap?.[0] ? prop.fc_36_anexoviverosmap?.[0]?.validacioncheck : false,
                idMap: prop.fc_36_anexoviverosmap?.[0] ? prop.fc_36_anexoviverosmap?.[0]?.idfc_36_anexoviverosmap : '',
            })
        }

        const arrayDocumentacion = []
        if (solicitud.fc_36_anexoviveros[index].alta == true && solicitud.fc_36_anexoviveros[index].baja == null || solicitud.cambiorazon) {
            for (const i in prop.fc_36archivovivero) {
                const documentacion = {
                    tabla: 'fc_36archivovivero',
                    nombreId: 'idfc_36_anexoviveros',
                    idSolicitud: prop.fc_36archivovivero[i].idfc_36_anexoviveros,
                    nameid: prop.fc_36archivovivero[i].nameid,
                }
                const nameId = prop.fc_36archivovivero[i].nameid
                let nameDoc = ''
                if ((nameId).includes('COPIAESC')) nameDoc = 'Copia de escritura'
                else if ((nameId).includes('CONSPOS')) nameDoc = 'Constancia de posesión'
                else if ((nameId).includes('CONARREN')) nameDoc = 'Contrato de arrendamiento'
                else if ((nameId).includes('IOVARREN')) nameDoc = 'Identificación oficial vigente de arrendador'
                else if ((nameId).includes('IOVCOMPR')) nameDoc = 'Identificación oficial vigente de comprador'
                else if ((nameId).includes('CONCOMPR')) nameDoc = 'Contrato de compraventa'
                else if ((nameId).includes('CONCOMODA')) nameDoc = 'Contrato de comodato'
                else if ((nameId).includes('IOVCOMTE')) nameDoc = 'Identificación oficial vigente de comodante'
                else if ((nameId).includes('IOVCOMRIO')) nameDoc = 'Identificación oficial vigente de comodatario'

                arrayDocumentacion.push(documentacion)
                let fechaInicio = moment(prop.fc_36archivovivero[i].fechainicio).add(1, 'd').format('YYYY-MM-DD')
                let fechaTermino = moment(prop.fc_36archivovivero[i].fechafin).add(1, 'd').format('YYYY-MM-DD')
                paginaDoc.push({
                    id: uuidv4(),
                    observaciones: prop.fc_36archivovivero[i].fc_36archivoviveromap?.[0] ? prop.fc_36archivovivero[i].fc_36archivoviveromap?.[0]?.observacion : '',
                    correcto: prop.fc_36archivovivero[i].fc_36archivoviveromap?.[0] ? !prop.fc_36archivovivero[i].fc_36archivoviveromap?.[0]?.estatuscheck : false,
                    incorrecto: prop.fc_36archivovivero[i].fc_36archivoviveromap?.[0] ? prop.fc_36archivovivero[i].fc_36archivoviveromap?.[0]?.estatuscheck : false,
                    fechaInicio: prop.fc_36archivovivero[i].fechainicio !== null ? fechaInicio : '',
                    fechaTermino: prop.fc_36archivovivero[i].fechafin !== null ? fechaTermino : '',
                    estatus: prop.fc_36archivovivero[i].estatus !== null ? prop.fc_36archivovivero[i].estatus : 'Agregar',
                    idMap: prop.fc_36archivovivero[i].fc_36archivoviveromap?.[0] ? prop.fc_36archivovivero[i].fc_36archivoviveromap?.[0]?.idfc_36archivoviveromap : '',
                    tabla: 'fc_36archivovivero',
                    nombreId: 'idfc_36_anexoviveros', idSolicitud: prop.fc_36archivovivero[i].idfc_36_anexoviveros,
                    nameid: nameId, nameDoc: nameDoc + ' del paraje: ' + prop.nombreparaje,
                    idAnexo: prop.fc_36archivovivero[i].idfc_36archivovivero,
                    idfc_36archivovivero: prop.fc_36archivovivero[i].idfc_36archivovivero
                })
            }
        }

    }
    let [rowsVivero, setRowsVivero] = React.useState([...vivero])

    let predio = []
    for (const index in solicitud.fc_36_anexopredio) {
        if (solicitud.fc_36_anexopredio[index].alta == true && solicitud.fc_36_anexopredio[index].baja == null || solicitud.cambiorazon) {
            paginaDoc.push({ id: uuidv4(), nameDoc: 'Documentación del predio: ' + solicitud.fc_36_anexopredio[index].nombreparaje })
        }
        const { ...prop } = solicitud.fc_36_anexopredio[index]

        let primeraLetra = prop.nombreparaje.charAt(0).toUpperCase()
        let cadena = primeraLetra + prop.nombreparaje.substring(1, prop.nombreparaje.length)
        let cultivado = 'No'
        let semicultivado = 'No'
        let silvestre = 'No'
        if (prop.cultivado) cultivado = 'Si'
        if (prop.semicultivado) semicultivado = 'Si'
        if (prop.silvestre) silvestre = 'Si'
        if (prop.baja == true || prop.alta == true || solicitud.cambiorazon) {
            predio.push({
                id: uuidv4(), idfc36_anexopredio: prop.idfc36_anexopredio,
                Campo: `Domicilio`, domicilio: prop.localidad + ';' + prop.municipio + ';' + prop.distrito + ';' + prop.estado,
                cultivado: cultivado, semicultivado: semicultivado, silvestre: silvestre,
                nombreparaje: prop.nombreparaje,
                baja: prop.baja,
                alta: prop.alta,
                isbaja: prop.isbaja,
                observaciones: prop.fc_36_anexoprediomap?.[0] ? prop.fc_36_anexoprediomap[0]?.observacion : '',
                correcto: prop.fc_36_anexoprediomap?.[0] ? !prop.fc_36_anexoprediomap[0]?.validacioncheck : false,
                incorrecto: prop.fc_36_anexoprediomap?.[0] ? prop.fc_36_anexoprediomap[0]?.validacioncheck : false,
                idMap: prop.fc_36_anexoprediomap?.[0]?.idfc36_anexoprediomap,
                //arrayDocumentacion
            })
        }
        const arrayDocumentacion = []
        if (solicitud.fc_36_anexopredio[index].alta == true && solicitud.fc_36_anexopredio[index].baja == null || solicitud.cambiorazon) {

            for (const i in prop.fc_36archivopredio) {
                const documentacion = {
                    tabla: 'fc_36archivopredio',
                    nombreId: 'idfc36_anexopredio',
                    idSolicitud: prop.fc_36archivopredio[i].idfc36_anexopredio,
                    nameid: prop.fc_36archivopredio[i].nameid,
                }
                const nameId = prop.fc_36archivopredio[i].nameid
                let nameDoc = ''
                if ((nameId).includes('COPIAESC')) nameDoc = 'Copia de escritura'
                else if ((nameId).includes('CONSPOS')) nameDoc = 'Constancia de posesión'
                else if ((nameId).includes('CONARREN')) nameDoc = 'Contrato de arrendamiento'
                else if ((nameId).includes('IOVARREN')) nameDoc = 'Identificación oficial vigente de arrendador'
                else if ((nameId).includes('IOVCOMPR')) nameDoc = 'Identificación oficial vigente de comprador'
                else if ((nameId).includes('CONCOMPR')) nameDoc = 'Contrato de compraventa'
                else if ((nameId).includes('CONCOMODA')) nameDoc = 'Contrato de comodato'
                else if ((nameId).includes('IOVCOMTE')) nameDoc = 'Identificación oficial vigente de comodante'
                else if ((nameId).includes('IOVCOMRIO')) nameDoc = 'Identificación oficial vigente de comodatario'

                arrayDocumentacion.push(documentacion)
                let fechaInicio = moment(prop.fc_36archivopredio[i].fechainicio).add(1, 'd').format('YYYY-MM-DD')
                let fechaTermino = moment(prop.fc_36archivopredio[i].fechafin).add(1, 'd').format('YYYY-MM-DD')
                paginaDoc.push({
                    id: uuidv4(),
                    observaciones: prop.fc_36archivopredio[i].fc_36archivoprediomap?.[0] ? prop.fc_36archivopredio[i].fc_36archivoprediomap?.[0]?.observacion : '',
                    correcto: prop.fc_36archivopredio[i].fc_36archivoprediomap?.[0] ? !prop.fc_36archivopredio[i].fc_36archivoprediomap?.[0]?.estatuscheck : false,
                    incorrecto: prop.fc_36archivopredio[i].fc_36archivoprediomap?.[0] ? prop.fc_36archivopredio[i].fc_36archivoprediomap?.[0]?.estatuscheck : false,
                    fechaInicio: prop.fc_36archivopredio[i].fechainicio !== null ? fechaInicio : '',
                    fechaTermino: prop.fc_36archivopredio[i].fechafin !== null ? fechaTermino : '',
                    estatus: prop.fc_36archivopredio[i].estatus !== null ? prop.fc_36archivopredio[i].estatus : 'Agregar',
                    idMap: prop.fc_36archivopredio[i].fc_36archivoprediomap?.[0] ? prop.fc_36archivopredio[i].fc_36archivoprediomap?.[0]?.idfc_36archivoprediomap : '',
                    tabla: 'fc_36archivopredio',
                    nombreId: 'idfc_36archivopredio', idSolicitud: prop.fc_36archivopredio[i].idfc_36archivopredio,
                    nameid: nameId, nameDoc: nameDoc + ' del paraje: ' + prop.nombreparaje,
                    idAnexo: prop.fc_36archivopredio[i].idfc_36archivopredio,
                    idfc_36archivopredio: prop.fc_36archivopredio[i].idfc_36archivopredio,
                })
            }
        }

    }
    let [rowsPredio, setRowsPredio] = React.useState([...predio])
    let marcas = []
    for (const i in solicitud.fc_36_anexomarcas) {
        if (solicitud.fc_36_anexomarcas[i].alta == true && solicitud.fc_36_anexomarcas[i].baja == null || (solicitud.cambiorazon && solicitud.fc_36_anexomarcas[i].baja != true) ||
            (solicitud.actualizacioncadena && (!solicitud.envasador || !solicitud.productormezcal) &&
                (solicitud.envasadoraltabaja || (!solicitud.productormezcal && solicitud.productormezcalaltabaja)))) {
            paginaDoc.push({ id: uuidv4(), nameDoc: 'Documentación de la marca: ' + solicitud.fc_36_anexomarcas[i].marca })
        }
        let { ...prop } = solicitud.fc_36_anexomarcas[i]
        let marcaregistrada = ''
        if (prop.registrosi) marcaregistrada = 'Si'
        if (prop.registrono) marcaregistrada = 'No'
        let tipomarca = ''
        if (prop.idtipomarca == 1) tipomarca = 'Mixta'
        if (prop.idtipomarca == 2) tipomarca = 'Nominativa'
        if (prop.idtipomarca == 3) tipomarca = 'Tridimencional'
        let titularidad = ''
        if (prop.idtitularidaddemarca == 1) titularidad = 'Propia (Título)'
        if (prop.idtitularidaddemarca == 2) titularidad = 'Propia en trámite'
        if (prop.idtitularidaddemarca == 3) titularidad = 'Licencia de uso autorizado'
        if (prop.idtitularidaddemarca == 4) titularidad = 'Cesión de derechos de marca autorizada'
        if (prop.idtitularidaddemarca == 5) titularidad = 'Licencia de uso en trámite'
        if (prop.idtitularidaddemarca == 6) titularidad = 'Cesión de derechos de marca en trámite'
        if (prop.baja === true || prop.alta === true || solicitud.cambiorazon) {
            marcas.push({
                id: uuidv4(), idfc36_anexomarcas: prop.idfc36_anexomarcas, marcaregistrada: marcaregistrada,
                nombremarca: prop.marca, numeroregistro: prop.numeroderegistroimpi,
                tipomarca: tipomarca, titularidad: titularidad, productorautorizado: prop.productor,
                maquiladorautorizado: prop.maquilador, relacioncontacto: prop.relacioncontacto,
                baja: prop.baja, alta: prop.alta, isbaja: prop.isbaja, iscorregida: prop.iscorregida,
                observaciones: prop.fc_36_anexomarcasmap ? prop.fc_36_anexomarcasmap?.[0]?.observacion : '',
                correcto: prop.fc_36_anexomarcasmap?.[0] ? !prop.fc_36_anexomarcasmap?.[0]?.validacioncheck : false,
                incorrecto: prop.fc_36_anexomarcasmap?.[0] ? prop.fc_36_anexomarcasmap?.[0]?.validacioncheck : false,
                idMap: prop.fc_36_anexomarcasmap?.[0]?.idfc36_anexomarcasmap,
            })
        }
        if (solicitud.fc_36_anexomarcas[i].alta == true || solicitud.cambiorazon ||
            (solicitud.actualizacioncadena && (solicitud.envasadoraltabaja || solicitud.productormezcalaltabaja))) {
            for (const j in prop.fc_36_archivosmarcas) {
                const nameId = prop.fc_36_archivosmarcas[j].nameid
                let nameDoc = ''
                if ((nameId).includes('TITULO')) nameDoc = 'Título de la marca'
                if ((nameId).includes('LICAUT')) nameDoc = 'Licencia de uso autorizada'
                if ((nameId).includes('CESAUT')) nameDoc = 'Cesión de derechos de marca autorizada'
                if ((nameId).includes('LICT')) nameDoc = 'Acuse de la licencia de uso de marca'
                if ((nameId).includes('CRLT')) nameDoc = 'Carta responsiva por trámite de licencia de uso'
                if ((nameId).includes('CESMT')) nameDoc = 'Acuse de la cesion de derechos de marca en trámite'
                if ((nameId).includes('CRCDMT')) nameDoc = 'Carta responsiva por trámite de cesión de derechos de marca'
                if ((nameId).includes('CM')) nameDoc = 'Acuse del registro de marca'
                if ((nameId).includes('CRMT')) nameDoc = 'Carta responsiva por trámite de registro de marca'
                if ((nameId).includes('CRMLT')) nameDoc = 'Carta responsiva por trámite de registro de: marca y licencia de uso'
                if ((nameId).includes('CEST')) nameDoc = 'Acuse de la cesión de derechos de marca en trámite'
                if ((nameId).includes('CRMCT')) nameDoc = 'Carta responsiva por trámite de: registro de marca y cesión de derechos de marca'
                if ((nameId).includes('JE')) nameDoc = 'Juego de etiquetas de la marca'
                if ((nameId).includes('MARCAMEZCALCONVENIO')) nameDoc = 'Convenio de corresponsabilidad'
                if ((nameId).includes('MARCAMEZCALCONTRATO')) nameDoc = 'Contrato de maquila'
                let fechaInicio = moment(prop?.fc_36_archivosmarcas[j].fechainicio).add(1, 'd').format('YYYY-MM-DD')
                let fechaTermino = moment(prop?.fc_36_archivosmarcas[j].fechafin).add(1, 'd').format('YYYY-MM-DD')
                paginaDoc.push({
                    id: uuidv4(),
                    observaciones: prop?.fc_36_archivosmarcas?.[j].fc_36_archivosmarcasmap?.[0] ? prop?.fc_36_archivosmarcas?.[j].fc_36_archivosmarcasmap?.[0]?.observacion : '',
                    correcto: prop?.fc_36_archivosmarcas?.[j].fc_36_archivosmarcasmap?.[0] ? !prop?.fc_36_archivosmarcas?.[j].fc_36_archivosmarcasmap?.[0]?.estatuscheck : false,
                    incorrecto: prop?.fc_36_archivosmarcas?.[j].fc_36_archivosmarcasmap?.[0] ? prop?.fc_36_archivosmarcas?.[j].fc_36_archivosmarcasmap?.[0]?.estatuscheck : false,
                    fechaInicio: prop?.fc_36_archivosmarcas[j].fechainicio ? fechaInicio : '',
                    fechaTermino: prop?.fc_36_archivosmarcas[j].fechafin ? fechaTermino : '',
                    estatus: prop?.fc_36_archivosmarcas[j].estatus ? prop?.fc_36_archivosmarcas[j].estatus : 'Agregar',
                    idMap: prop?.fc_36_archivosmarcas?.[j].fc_36_archivosmarcasmap?.[0] ? prop?.fc_36_archivosmarcas?.[j].fc_36_archivosmarcasmap?.[0]?.idarchivosmarcamap : '',
                    idarchivosmarca: prop?.fc_36_archivosmarcas[j].idarchivosmarca,
                    tabla: 'fc_36_archivosmarcas', nombreId: 'idfc36_anexomarcas',
                    idSolicitud: prop?.idfc36_anexomarcas,
                    nameid: nameId, nameDoc: nameDoc,
                })
            }
        }
    }
    let [rowsMarcas, setRowsMarcas] = React.useState([...marcas])
    let marcasBebidas = []
    for (const i in solicitud.fc_36_anexomarcasproductoconmezcal) {
        if (solicitud.fc_36_anexomarcasproductoconmezcal[i].alta == true || (solicitud.cambiorazon && solicitud.fc_36_anexomarcasproductoconmezcal[i].alta == true) ||
            (solicitud.actualizacioncadena && ((!solicitud.envasador && solicitud.envasadoraltabaja) || (!solicitud.productormezcal && solicitud.productormezcalaltabaja)))) {
            paginaDoc.push({ id: uuidv4(), nameDoc: 'Documentación de la marca de bebida con mezcal: ' + solicitud.fc_36_anexomarcasproductoconmezcal?.[i]?.marca })
        }
        let { ...prop } = solicitud.fc_36_anexomarcasproductoconmezcal[i]
        let marcaregistrada = ''
        if (prop.registrosi) marcaregistrada = 'Si'
        if (prop.registrono) marcaregistrada = 'No'
        let tipomarca = ''
        if (prop.idtipomarca == 1) tipomarca = 'Mixta'
        if (prop.idtipomarca == 2) tipomarca = 'Nominativa'
        if (prop.idtipomarca == 3) tipomarca = 'Tridimencional'
        let titularidad = ''
        if (prop.idtitularidaddemarca == 1) titularidad = 'Propia (Título)'
        if (prop.idtitularidaddemarca == 2) titularidad = 'Propia en trámite'
        if (prop.idtitularidaddemarca == 3) titularidad = 'Licencia de uso autorizado'
        if (prop.idtitularidaddemarca == 4) titularidad = 'Cesión de derechos de marca autorizada'
        if (prop.idtitularidaddemarca == 5) titularidad = 'Licencia de uso en trámite'
        if (prop.idtitularidaddemarca == 6) titularidad = 'Cesión de derechos de marca en trámite'
        if (prop.baja === true || prop.alta === true || solicitud.cambiorazon) {
            marcasBebidas.push({
                id: uuidv4(), idfc36_anexomarcasproductoconmezcal: prop.idfc36_anexomarcasproductoconmezcal, marcaregistrada: marcaregistrada,
                nombremarca: prop.marca, numeroregistro: prop.numeroderegistroimpi,
                tipomarca: tipomarca, titularidad: titularidad, productorautorizado: prop.productor,
                maquiladorautorizado: prop.maquilador, relacioncontacto: prop.relacioncontacto,
                baja: prop.baja, alta: prop.alta, isbaja: prop.isbaja, iscorregida: prop.iscorregida,
                observaciones: prop.fc_36_anexomarcasproductoconmezcalmap ? prop.fc_36_anexomarcasproductoconmezcalmap?.[0]?.observacion : '',
                correcto: prop.fc_36_anexomarcasproductoconmezcalmap?.[0] ? !prop.fc_36_anexomarcasproductoconmezcalmap?.[0]?.validacioncheck : false,
                incorrecto: prop.fc_36_anexomarcasproductoconmezcalmap?.[0] ? prop.fc_36_anexomarcasproductoconmezcalmap?.[0]?.validacioncheck : false,
                idMap: prop.fc_36_anexomarcasproductoconmezcalmap?.[0]?.idfc36_anexomarcasproductoconmezcalmap,
            })
        }
        if (solicitud.fc_36_anexomarcasproductoconmezcal[i].alta == true || solicitud.cambiorazon ||
            (solicitud.actualizacioncadena && (solicitud.envasadoraltabaja || solicitud.productormezcalaltabaja))) {
            for (const j in prop.fc_36_archivosmarcasproducto) {
                const nameId = prop.fc_36_archivosmarcasproducto[j].nameid
                let nameDoc = ''
                if ((nameId).includes('TITULO')) nameDoc = 'Título de la marca'
                if ((nameId).includes('LICAUT')) nameDoc = 'Licencia de uso autorizada'
                if ((nameId).includes('CESAUT')) nameDoc = 'Cesión de derechos autorizada de la marca'
                if ((nameId).includes('LICT')) nameDoc = 'Acuse de la licencia de uso'
                if ((nameId).includes('CRLT')) nameDoc = 'Carta responsiva por trámite de licencia de uso'
                if ((nameId).includes('CESMT')) nameDoc = 'Acuse de la cesion de derechos de marca en trámite'
                if ((nameId).includes('CRCDMT')) nameDoc = 'Carta responsiva por trámite de cesión de derechos de marca'
                if ((nameId).includes('CM')) nameDoc = 'Acuse del registro de marca'
                if ((nameId).includes('CRMT')) nameDoc = 'Carta responsiva eCarta responsiva por trámite de registro de marca'
                if ((nameId).includes('CRMLT')) nameDoc = 'Carta responsiva por trámite de registro de: marca y licencia de uso'
                if ((nameId).includes('CEST')) nameDoc = 'Acuse de la cesión de derechos de marca en trámite'
                if ((nameId).includes('CRMCT')) nameDoc = 'Carta responsiva por trámite de: registro de marca y cesión de derechos de marca'
                if ((nameId).includes('JE')) nameDoc = 'Juego de etiquetas de la marca'
                if ((nameId).includes('MARCACONMEZCALCONVENIO')) nameDoc = 'Convenio de corresponsabilidad'
                if ((nameId).includes('MARCACONMEZCALCONTRATO')) nameDoc = 'Contrato de maquila'
                let fechaInicio = moment(prop?.fc_36_archivosmarcasproducto[j].fechainicio).add(1, 'd').format('YYYY-MM-DD')
                let fechaTermino = moment(prop?.fc_36_archivosmarcasproducto[j].fechafin).add(1, 'd').format('YYYY-MM-DD')
                paginaDoc.push({
                    id: uuidv4(),
                    observaciones: prop?.fc_36_archivosmarcasproducto?.[j].fc_36_archivosmarcasproductomap?.[0] ? prop?.fc_36_archivosmarcasproducto?.[j].fc_36_archivosmarcasproductomap?.[0]?.observacion : '',
                    correcto: prop?.fc_36_archivosmarcasproducto?.[j].fc_36_archivosmarcasproductomap?.[0] ? !prop?.fc_36_archivosmarcasproducto?.[j].fc_36_archivosmarcasproductomap?.[0]?.estatuscheck : false,
                    incorrecto: prop?.fc_36_archivosmarcasproducto?.[j].fc_36_archivosmarcasproductomap?.[0] ? prop?.fc_36_archivosmarcasproducto?.[j].fc_36_archivosmarcasproductomap?.[0]?.estatuscheck : false,
                    fechaInicio: prop?.fc_36_archivosmarcasproducto[j].fechainicio ? fechaInicio : '',
                    fechaTermino: prop?.fc_36_archivosmarcasproducto[j].fechafin ? fechaTermino : '',
                    estatus: prop?.fc_36_archivosmarcasproducto[j].estatus ? prop?.fc_36_archivosmarcasproducto[j].estatus : 'Agregar',
                    idMap: prop?.fc_36_archivosmarcasproducto?.[j].fc_36_archivosmarcasproductomap?.[0] ? prop?.fc_36_archivosmarcasproducto?.[j].fc_36_archivosmarcasproductomap?.[0]?.idarchivosmarcaproductomap : '',
                    idarchivosmarcaproducto: prop?.fc_36_archivosmarcasproducto[j].idarchivosmarcaproducto,
                    tabla: 'fc_36_archivosmarcasproducto', nombreId: 'idfc36_anexomarcasproductoconmezcal',
                    idSolicitud: prop?.idfc36_anexomarcasproductoconmezcal,
                    nameid: nameId, nameDoc: nameDoc,
                })
            }
        }
    }
    let [rowsMarcasBebidas, setRowsMarcasBebidas] = React.useState([...marcasBebidas])
    let responsablesInst = []
    if (solicitud.cambioresponsableinst) paginaDoc.push({ id: uuidv4(), nameDoc: 'Documentación de actualización de responsables de instalación' })

    for (const i in solicitud.fc_36_actualizacionresponsableinstalaciones) {
        let { ...prop } = solicitud.fc_36_actualizacionresponsableinstalaciones[i]
        if (prop.alta || prop.baja ||
            solicitud.cambiorazon) {
            responsablesInst.push({
                id: uuidv4(), idfc_36_actulizarresponsableinstalaciones: prop.idfc_36_actulizarresponsableinstalaciones,
                tipoinstalacion: prop.tipoinstalacion, alias: prop.alias, responsableinstalacion: prop.nombreresponsable,
                telefono: prop.telefono, correoelectronico: prop.correoelectronico,
                relacioncontacto: prop.relacioncontacto,
                isbaja: prop.isbaja,
                baja: prop.baja,
                alta: prop.alta,
                domicilio: prop.domicilio,
                observaciones: prop.fc_36_actualizacionresponsableinstalacionesmap?.[0] ? prop.fc_36_actualizacionresponsableinstalacionesmap?.[0]?.observacion : '',
                correcto: prop.fc_36_actualizacionresponsableinstalacionesmap?.[0] ? !prop.fc_36_actualizacionresponsableinstalacionesmap?.[0]?.validacioncheck : false,
                incorrecto: prop.fc_36_actualizacionresponsableinstalacionesmap?.[0] ? prop.fc_36_actualizacionresponsableinstalacionesmap?.[0]?.validacioncheck : false,
                idMap: prop.fc_36_actualizacionresponsableinstalacionesmap?.[0] ? prop.fc_36_actualizacionresponsableinstalacionesmap?.[0]?.idfc_36_actulizarresponsableinstalacionesmap : '',
            })
        }
        if (prop.alta == true && prop.baja == null || solicitud.cambiorazon) {
            for (const j in prop.fc_36archivoactualizacionresponsables) {
                const nameId = prop.fc_36archivoactualizacionresponsables[j].nameid
                let nameDoc = ''
                if ((nameId).includes('ACTINSTREP')) nameDoc = 'Identificación oficial vigente del responsable'
                //if ((nameId).includes('LICAUT')) nameDoc = 'Licencia de uso autorizada'
                let fechaInicio = moment(prop?.fc_36archivoactualizacionresponsables[j].fechainicio).add(1, 'd').format('YYYY-MM-DD')
                let fechaTermino = moment(prop?.fc_36archivoactualizacionresponsables[j].fechafin).add(1, 'd').format('YYYY-MM-DD')
                paginaDoc.push({
                    id: uuidv4(),
                    observaciones: prop?.fc_36archivoactualizacionresponsables?.[j].fc_36archivoactualizacionresponsablesmap?.[0] ? prop?.fc_36archivoactualizacionresponsables?.[j].fc_36archivoactualizacionresponsablesmap?.[0]?.observacion : '',
                    correcto: prop?.fc_36archivoactualizacionresponsables?.[j].fc_36archivoactualizacionresponsablesmap?.[0] ? !prop?.fc_36archivoactualizacionresponsables?.[j].fc_36archivoactualizacionresponsablesmap?.[0]?.estatuscheck : false,
                    incorrecto: prop?.fc_36archivoactualizacionresponsables?.[j].fc_36archivoactualizacionresponsablesmap?.[0] ? prop?.fc_36archivoactualizacionresponsables?.[j].fc_36archivoactualizacionresponsablesmap?.[0]?.estatuscheck : false,
                    fechaInicio: prop?.fc_36archivoactualizacionresponsables[j].fechainicio ? fechaInicio : '',
                    fechaTermino: prop?.fc_36archivoactualizacionresponsables[j].fechafin ? fechaTermino : '',
                    estatus: prop?.fc_36archivoactualizacionresponsables[j].estatus ? prop?.fc_36archivoactualizacionresponsables[j].estatus : 'Agregar',
                    idMap: prop?.fc_36archivoactualizacionresponsables?.[j].fc_36archivoactualizacionresponsablesmap?.[0] ? prop?.fc_36archivoactualizacionresponsables?.[j].fc_36archivoactualizacionresponsablesmap?.[0]?.idfc_36archivoresponsablesmap : '',
                    idfc_36archivoresponsables: prop?.fc_36archivoactualizacionresponsables[j].idfc_36archivoresponsables,
                    tabla: 'fc_36archivoactualizacionresponsables', nombreId: 'idfc_36_actulizarresponsableinstalaciones',
                    idSolicitud: prop?.idfc_36_actulizarresponsableinstalaciones,
                    nameid: nameId, nameDoc: nameDoc,
                })
            }
        }
    }
    let [rowsResponsablesInst, setRowsResponsablesInst] = React.useState([...responsablesInst])

    let instalaciones = []
    for (const i in solicitud.fc_36anexo) {
        const { ...prop } = solicitud.fc_36anexo[i]
        if ((solicitud.actualizacioninstalaciones && prop.alta) || solicitud.cambiorazon || prop.alta) paginaDoc.push({ id: uuidv4(), nameDoc: 'Documentación de la ' + prop.tipoanexo.descripcion + ', alias: ' + (prop.fc_36informaciongeneral.alias).toUpperCase() })
        if (prop.alta || prop.baja || solicitud.cambiorazon) {
            instalaciones.push({
                id: uuidv4(), valor: (prop.tipoanexo.descripcion + ', alias: ' + prop.fc_36informaciongeneral.alias).toUpperCase(), align: 'center'
            })
        }
        let calleInstalacion = prop.fc_36informaciongeneral.calle
        if (prop.fc_36informaciongeneral.calle === 'Otro') calleInstalacion = prop.fc_36informaciongeneral.otracalle
        if (prop.baja === true || prop.alta === true || solicitud.cambiorazon || prop.isedicion) {
            let numerointerior = 's/n'
            if (prop.fc_36informaciongeneral.numerointerior != null) numerointerior = prop.fc_36informaciongeneral.numerointerior
            instalaciones.push({
                id: uuidv4(), idfc_36informaciongeneral: prop.fc_36informaciongeneral.idfc_36informaciongeneral,
                Campo: 'Domicilio de instalación', valor: calleInstalacion + ';' + numerointerior + ';' +
                    prop.fc_36informaciongeneral.numeroexterior + ';' + prop.fc_36informaciongeneral.colonia + ';' + prop.fc_36informaciongeneral.localidad + ';' + prop.fc_36informaciongeneral.municipio
                    + ';' + prop.fc_36informaciongeneral.estado + ';' + prop.fc_36informaciongeneral.codigopostal,
                relacioncontacto: prop.fc_36informaciongeneral.relacioncontacto,
                baja: prop.baja,
                alta: prop.alta,
                isbaja: prop.isbaja,
                isedicion: prop.isedicion,
                fc_36_dataelemento: prop.fc_36_dataelemento,
                observaciones: prop.fc_36informaciongeneral.fc_36informaciongeneralmap?.[0] ? prop.fc_36informaciongeneral.fc_36informaciongeneralmap[0]?.observacion : '',
                correcto: prop.fc_36informaciongeneral.fc_36informaciongeneralmap?.[0] ? !prop.fc_36informaciongeneral.fc_36informaciongeneralmap?.[0]?.validacioncheck : false,
                incorrecto: prop.fc_36informaciongeneral.fc_36informaciongeneralmap?.[0] ? prop.fc_36informaciongeneral.fc_36informaciongeneralmap?.[0]?.validacioncheck : false,
                idMap: prop.fc_36informaciongeneral.fc_36informaciongeneralmap?.[0]?.idfc_36informaciongeneral,
                estatusDomicilio: prop.fc_36informaciongeneral.domiciliodenominacionorigen,
                anexoexistente: prop.fc_36informaciongeneral.anexoexistente !== null ? prop.fc_36informaciongeneral.anexoexistente : false
            })
        }

        if (prop.alta == true || solicitud.cambiorazon) {
            for (const j in prop.fc_36_archivosinstalaciones) {
                const nameId = prop.fc_36_archivosinstalaciones[j].nameid
                let nameDoc = ''
                if ((nameId).includes('TITULOINS')) nameDoc = 'Copia del título de propiedad a nombre del solicitante'
                if ((nameId).includes('CAINSP')) nameDoc = 'Contrato de arrendamiento público (notariado)'
                if ((nameId).includes('CAINS')) nameDoc = 'Contrato de arrendamiento'
                if ((nameId).includes('IOVRINS')) nameDoc = 'Identificación oficial vigente del Arrendador'
                if ((nameId).includes('IOVOINS')) nameDoc = 'Identificación oficial vigente del Arrendatario'
                if ((nameId).includes('CCINSP')) nameDoc = 'Contrato comodato público (notariado)'
                if ((nameId).includes('CCINS')) nameDoc = 'Contrato comodato'
                if ((nameId).includes('IOVEINS')) nameDoc = 'Identificación oficial vigente del comodante'
                if ((nameId).includes('IOVOINS')) nameDoc = 'Identificación oficial vigente del comodatario'
                let fechaInicio = moment(prop?.fc_36_archivosinstalaciones[j].fechainicio).add(1, 'd').format('YYYY-MM-DD')
                let fechaTermino = moment(prop?.fc_36_archivosinstalaciones[j].fechafin).add(1, 'd').format('YYYY-MM-DD')
                paginaDoc.push({
                    id: uuidv4(),
                    observaciones: prop?.fc_36_archivosinstalaciones[j]?.fc_36_archivosinstalacionesmap?.[0] ? prop?.fc_36_archivosinstalaciones[j]?.fc_36_archivosinstalacionesmap[0]?.observacion : '',
                    correcto: prop?.fc_36_archivosinstalaciones[j]?.fc_36_archivosinstalacionesmap?.[0] ? !prop?.fc_36_archivosinstalaciones[j]?.fc_36_archivosinstalacionesmap[0]?.estatuscheck : false,
                    incorrecto: prop?.fc_36_archivosinstalaciones[j]?.fc_36_archivosinstalacionesmap?.[0] ? prop?.fc_36_archivosinstalaciones[j]?.fc_36_archivosinstalacionesmap[0]?.estatuscheck : false,
                    fechaInicio: prop?.fc_36_archivosinstalaciones[j].fechainicio ? fechaInicio : '',
                    fechaTermino: prop?.fc_36_archivosinstalaciones[j].fechafin ? fechaTermino : '',
                    estatus: prop?.fc_36_archivosinstalaciones[j].estatus ? prop?.fc_36_archivosinstalaciones[j].estatus : 'Agregar',
                    idMap: prop?.fc_36_archivosinstalaciones[j]?.fc_36_archivosinstalacionesmap[0] ? prop?.fc_36_archivosinstalaciones[j]?.fc_36_archivosinstalacionesmap?.[0]?.idarchivosinstalacionmap : '',
                    idarchivosinstalacion: prop?.fc_36_archivosinstalaciones[j].idarchivosinstalacion,
                    tabla: 'fc_36_archivosinstalaciones', nombreId: 'idfc_36anexo',
                    idSolicitud: prop?.idfc_36anexo,
                    nameid: nameId, nameDoc: nameDoc,
                })
            }
        }

        for (const dato of prop.fc_36informaciongeneral.fc_36responsablesdeinstalacion) {
            const arrayDocument = []

            for (const j in dato.fc_36_archivosresposansables) {
                const nameId = dato.fc_36_archivosresposansables[j].nameid
                let nameDoc = ''
                if ((nameId).includes('INSTREP')) nameDoc = 'Identificación oficial vigente del responsable: ' + dato.nombreresponsable
                let fechaInicio = moment(dato?.fc_36_archivosresposansables[j].fechainicio).add(1, 'd').format('YYYY-MM-DD')
                let fechaTermino = moment(dato?.fc_36_archivosresposansables[j].fechafin).add(1, 'd').format('YYYY-MM-DD')
                paginaDoc.push({
                    id: uuidv4(),
                    observaciones: dato?.fc_36_archivosresposansables[j].fc_36_archivosresposansablesmap?.[0] ? dato?.fc_36_archivosresposansables[j].fc_36_archivosresposansablesmap?.[0]?.observacion : '',
                    correcto: dato?.fc_36_archivosresposansables[j].fc_36_archivosresposansablesmap?.[0] ? !dato?.fc_36_archivosresposansables[j].fc_36_archivosresposansablesmap?.[0]?.estatuscheck : false,
                    incorrecto: dato?.fc_36_archivosresposansables[j].fc_36_archivosresposansablesmap?.[0] ? dato?.fc_36_archivosresposansables[j].fc_36_archivosresposansablesmap?.[0]?.estatuscheck : false,
                    fechaInicio: dato?.fc_36_archivosresposansables[j].fechainicio ? fechaInicio : '',
                    fechaTermino: dato?.fc_36_archivosresposansables[j].fechafin ? fechaTermino : '',
                    estatus: dato?.fc_36_archivosresposansables[j].estatus ? dato?.fc_36_archivosresposansables[j].estatus : 'Agregar',
                    idMap: dato?.fc_36_archivosresposansables[j].fc_36_archivosresposansablesmap?.[0] ? dato?.fc_36_archivosresposansables[j].fc_36_archivosresposansablesmap?.[0]?.idarchivosresponsablesmap : '',
                    idarchivosresponsables: dato?.fc_36_archivosresposansables[j].idarchivosresponsables,
                    tabla: 'fc_36_archivosresposansables', nombreId: 'idfc_36responsabledeinstalacion',
                    idSolicitud: dato?.idfc_36responsabledeinstalacion,
                    idfc_36responsabledeinstalacion: dato?.idfc_36responsabledeinstalacion,
                    nameid: nameId, nameDoc: nameDoc,
                })
            }

            if (prop.baja || prop.alta || solicitud.cambiorazon) {
                instalaciones.push({
                    id: uuidv4(), idfc_36responsabledeinstalacion: dato.idfc_36responsabledeinstalacion,
                    Campo: 'Nombre del responsable', valor: dato.nombreresponsable,
                    observaciones: dato.responsablesdeinstalacionmap?.[0] ? dato.responsablesdeinstalacionmap?.[0]?.observacion : '',
                    correcto: dato.responsablesdeinstalacionmap?.[0] ? !dato.responsablesdeinstalacionmap?.[0]?.validacioncheck : false,
                    incorrecto: dato.responsablesdeinstalacionmap?.[0] ? dato.responsablesdeinstalacionmap?.[0]?.validacioncheck : false,
                    idMap: dato.responsablesdeinstalacionmap?.[0]?.idfc_36responsabledeinstalacionmap,
                    arrayDocumentacion: arrayDocument
                })
            }
        }

    }

    let [rowsInstalaciones, setRowsInstalaciones] = React.useState([...instalaciones])
    let [rowspaginaDoc, setRowsPaginaDoc] = React.useState(paginaDoc)
    const handdleEditPrev = (objectProducto) => {

        const filtroDatos = rowspaginaGeneral.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroMedios = rowspagina1.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroPersona = rowspagina2.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroResponsable = rowspagina3.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDomicilio = rowspaginaDomiclio.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDocumentacion = rowspaginaDoc.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroPredios = rowsPredio.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroViveros = rowsVivero.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroMarcas = rowsMarcas.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroMarcasBebidas = rowsMarcasBebidas.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroInstalaciones = rowsInstalaciones.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroResponsablesInst = rowsResponsablesInst.findIndex(anexo => anexo.id === objectProducto.id)

        if (filtroDatos !== -1) {
            rowspaginaGeneral[filtroDatos].valor = objectProducto.valor
            rowspaginaGeneral[filtroDatos].correcto = objectProducto.correcto
            rowspaginaGeneral[filtroDatos].incorrecto = objectProducto.incorrecto
            rowspaginaGeneral[filtroDatos].observaciones = objectProducto.observaciones
        }
        if (filtroMedios !== -1) {
            rowspagina1[filtroMedios].valor = objectProducto.valor
            rowspagina1[filtroMedios].correcto = objectProducto.correcto
            rowspagina1[filtroMedios].incorrecto = objectProducto.incorrecto
            rowspagina1[filtroMedios].observaciones = objectProducto.observaciones
        }
        if (filtroPersona !== -1) {
            rowspagina2[filtroPersona].valor = objectProducto.valor
            rowspagina2[filtroPersona].correcto = objectProducto.correcto
            rowspagina2[filtroPersona].incorrecto = objectProducto.incorrecto
            rowspagina2[filtroPersona].observaciones = objectProducto.observaciones
        }
        if (filtroResponsable !== -1) {
            rowspagina3[filtroResponsable].valor = objectProducto.valor
            rowspagina3[filtroResponsable].correcto = objectProducto.correcto
            rowspagina3[filtroResponsable].incorrecto = objectProducto.incorrecto
            rowspagina3[filtroResponsable].observaciones = objectProducto.observaciones
        }
        if (filtroDomicilio !== -1) {
            rowspaginaDomiclio[filtroDomicilio].valor = objectProducto.valor
            rowspaginaDomiclio[filtroDomicilio].correcto = objectProducto.correcto
            rowspaginaDomiclio[filtroDomicilio].incorrecto = objectProducto.incorrecto
            rowspaginaDomiclio[filtroDomicilio].observaciones = objectProducto.observaciones
        }
        if (filtroPredios !== -1) {
            rowsPredio[filtroPredios].valor = objectProducto.valor
            rowsPredio[filtroPredios].correcto = objectProducto.correcto
            rowsPredio[filtroPredios].incorrecto = objectProducto.incorrecto
            rowsPredio[filtroPredios].observaciones = objectProducto.observaciones
        }
        if (filtroViveros !== -1) {
            rowsVivero[filtroViveros].valor = objectProducto.valor
            rowsVivero[filtroViveros].correcto = objectProducto.correcto
            rowsVivero[filtroViveros].incorrecto = objectProducto.incorrecto
            rowsVivero[filtroViveros].observaciones = objectProducto.observaciones
        }
        if (filtroMarcas !== -1) {
            rowsMarcas[filtroMarcas].valor = objectProducto.valor
            rowsMarcas[filtroMarcas].correcto = objectProducto.correcto
            rowsMarcas[filtroMarcas].incorrecto = objectProducto.incorrecto
            rowsMarcas[filtroMarcas].observaciones = objectProducto.observaciones
        }
        if (filtroMarcasBebidas !== -1) {
            rowsMarcasBebidas[filtroMarcasBebidas].valor = objectProducto.valor
            rowsMarcasBebidas[filtroMarcasBebidas].correcto = objectProducto.correcto
            rowsMarcasBebidas[filtroMarcasBebidas].incorrecto = objectProducto.incorrecto
            rowsMarcasBebidas[filtroMarcasBebidas].observaciones = objectProducto.observaciones
        }
        if (filtroInstalaciones !== -1) {
            rowsInstalaciones[filtroInstalaciones].valor = objectProducto.valor
            rowsInstalaciones[filtroInstalaciones].correcto = objectProducto.correcto
            rowsInstalaciones[filtroInstalaciones].incorrecto = objectProducto.incorrecto
            rowsInstalaciones[filtroInstalaciones].observaciones = objectProducto.observaciones
        }
        if (filtroResponsablesInst !== -1) {
            rowsResponsablesInst[filtroResponsablesInst].valor = objectProducto.valor
            rowsResponsablesInst[filtroResponsablesInst].correcto = objectProducto.correcto
            rowsResponsablesInst[filtroResponsablesInst].incorrecto = objectProducto.incorrecto
            rowsResponsablesInst[filtroResponsablesInst].observaciones = objectProducto.observaciones
        }
        if (filtroDocumentacion !== -1) {
            //rowspaginaDoc[filtroDocumentacion].valor = objectProducto.valor
            rowspaginaDoc[filtroDocumentacion].correcto = objectProducto.correcto
            rowspaginaDoc[filtroDocumentacion].incorrecto = objectProducto.incorrecto
            rowspaginaDoc[filtroDocumentacion].observaciones = objectProducto.observaciones
            rowspaginaDoc[filtroDocumentacion].estatus = objectProducto.estatus
            rowspaginaDoc[filtroDocumentacion].fechaInicio = objectProducto.fechaInicio
            rowspaginaDoc[filtroDocumentacion].fechaTermino = objectProducto.fechaTermino
        }
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_36())
    }
    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (solicitud.fc_36_solicituddeactualizacionmap.length === 0) {
            await agregarMapYActualizarFC_36()
            const idSolicitud = solicitud.idfc36_solicitudactualizacion
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_36 = 10
            const tabla = tablaFC_36
            await dispatch(actualizarFC_36Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_36()
            const idSolicitud = solicitud.idfc36_solicitudactualizacion
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_36 = 10
            const tabla = tablaFC_36
            await dispatch(actualizarFC_36Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const agregarMapYActualizarFC_36 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()


        let principalMap = []
        if (solicitud.cambiorazon) {
            principalMap.push({
                cambiorazon: rowspaginaGeneral[0].observaciones,
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                medioscontacto: '',

                cambiorazoncheck: rowspaginaGeneral[0].incorrecto,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
            })
        } else {
            if (solicitud.actualizacioninstalaciones) await principalMap.push({
                actualizacioninstalaciones: rowspaginaGeneral[0].observaciones,
                actualizacioninstalacionescheck: rowspaginaGeneral[0].incorrecto,
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioncadena: '',
                actualizacioncadenacheck: false,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                cambiorazon: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.actualizacionprediosviveros) await principalMap.push({
                actualizacionprediosviveros: rowspaginaGeneral[0].observaciones,
                actualizacionprediosviveroscheck: rowspaginaGeneral[0].incorrecto,
                actualizacioncadena: '',
                actualizacioncadenacheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                cambiorazon: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.actualizacioncadena) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                actualizacioncadena: rowspaginaGeneral[0].observaciones,
                actualizacioncadenacheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                cambiorazon: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.actualizaciondomicilio) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                actualizaciondomicilio: rowspaginaGeneral[0].observaciones,
                actualizaciondomiciliocheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                cambiorazon: '',
                actualizacioncadena: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.cambioresponsable) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                cambioresponsable: rowspaginaGeneral[0].observaciones,
                cambioresponsablecheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                cambiorazon: '',
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambiorepresentante: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.cambiorepresentante) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                cambiorepresentante: rowspaginaGeneral[0].observaciones,
                cambiorepresentantecheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                cambiorazon: '',
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.actualizarmedioscontacto) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                medioscontacto: rowspaginaGeneral[0].observaciones,
                medioscontactocheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                cambiorazon: '',
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
            })
            if (solicitud.cambioresponsableinst) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                cambioresponsableinst: rowspaginaGeneral[0].observaciones,
                cambioresponsableinstcheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                medioscontacto: '',
                medioscontactocheck: false,
                cambiorazon: '',
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
            })
            if (solicitud.actualizarmarcas) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                otro: rowspaginaGeneral[0].observaciones,
                otrocheck: rowspaginaGeneral[0].incorrecto,
                cambioresponsableinst: '',
                cambioresponsableinstcheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                medioscontacto: '',
                medioscontactocheck: false,
                cambiorazon: '',
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
            })

        }

        /*for (const i in rowspagina1) {
            if (rowspagina1?.[i].Campo === 'Entrega de hologramas para bebidas con mezcal') principalMap.push({ entregahologramasbebidasmezcal: rowspagina1[i].observaciones, entregahologramasbebidasmezcalcheck: rowspagina1[i].incorrecto })
        }
        let obj_unidos = {}
        for (const i in principalMap) {
            obj_unidos = Object.assign(obj_unidos, principalMap[i])
        }*/
        let mediosContactoMap = []
        for (const i in rowspagina1) {
            mediosContactoMap.push({ observacion: rowspagina1?.[i]?.observaciones, validacioncheck: rowspagina1?.[i]?.incorrecto, idfc36_anexomediodecontacto: rowspagina1?.[i]?.idfc36_anexomediodecontacto })
        }
        let personasAutorizadasMap = []
        for (const i in rowspagina2) {
            personasAutorizadasMap.push({ observacion: rowspagina2?.[i]?.observaciones, validacioncheck: rowspagina2?.[i]?.incorrecto, idfc36_anexopersonasautorizadas: rowspagina2?.[i]?.idfc36_anexopersonasautorizadas })
        }
        let representantesLegalesMap = []
        for (const i in rowspagina3) {
            representantesLegalesMap.push({ observacion: rowspagina3?.[i]?.observaciones, validacioncheck: rowspagina3?.[i]?.incorrecto, idfc36_anexoapoderadoslegales: rowspagina3?.[i]?.idfc36_anexoapoderadoslegales })
        }
        let domiciliosFiscalesMap = []
        for (const i in rowspaginaDomiclio) {
            domiciliosFiscalesMap.push({ observacion: rowspaginaDomiclio?.[i]?.observaciones, validacioncheck: rowspaginaDomiclio?.[i]?.incorrecto, idfc36_anexodomiciliosfiscales: rowspaginaDomiclio?.[i]?.idfc36_anexodomiciliosfiscales })
        }
        let prediosMap = []
        for (const i in rowsPredio) {
            prediosMap.push({ observacion: rowsPredio?.[i]?.observaciones, validacioncheck: rowsPredio?.[i]?.incorrecto, idfc36_anexopredio: rowsPredio?.[i]?.idfc36_anexopredio })
        }
        let viveroMap = []
        for (const i in rowsVivero) {
            viveroMap.push({ observacion: rowsVivero?.[i]?.observaciones, validacioncheck: rowsVivero?.[i]?.incorrecto, idfc_36_anexoviveros: rowsVivero?.[i]?.idfc_36_anexoviveros })
        }
        let marcasMap = []
        for (const i in rowsMarcas) {
            marcasMap.push({ observacion: rowsMarcas?.[i]?.observaciones, validacioncheck: rowsMarcas?.[i]?.incorrecto, idfc36_anexomarcas: rowsMarcas?.[i]?.idfc36_anexomarcas })
        }
        let marcasBebidasMap = []
        for (const i in rowsMarcasBebidas) {
            marcasBebidasMap.push({ observacion: rowsMarcasBebidas?.[i]?.observaciones, validacioncheck: rowsMarcasBebidas?.[i]?.incorrecto, idfc36_anexomarcasproductoconmezcal: rowsMarcasBebidas?.[i]?.idfc36_anexomarcasproductoconmezcal })
        }
        let ResponsablesInstMap = []
        for (const i in rowsResponsablesInst) {
            ResponsablesInstMap.push({ observacion: rowsResponsablesInst?.[i]?.observaciones, validacioncheck: rowsResponsablesInst?.[i]?.incorrecto, idfc_36_actulizarresponsableinstalaciones: rowsResponsablesInst?.[i]?.idfc_36_actulizarresponsableinstalaciones })
        }
        let InstalacionesDomicilioMap = []
        let InstalacionesResponsablesMap = []
        for (const i in rowsInstalaciones) {
            if (rowsInstalaciones[i].Campo === 'Domicilio de instalación') InstalacionesDomicilioMap.push({ observacion: rowsInstalaciones?.[i]?.observaciones, validacioncheck: rowsInstalaciones?.[i]?.incorrecto, idfc_36informaciongeneral: rowsInstalaciones?.[i]?.idfc_36informaciongeneral })
            if (rowsInstalaciones[i].Campo === 'Nombre del responsable') InstalacionesResponsablesMap.push({ observacion: rowsInstalaciones?.[i]?.observaciones, validacioncheck: rowsInstalaciones?.[i]?.incorrecto, idfc_36responsabledeinstalacion: rowsInstalaciones?.[i]?.idfc_36responsabledeinstalacion })

        }
        //Archivos para map
        let archivosRepresentanteLegalMap = []
        let archivosPersonasAutorizadasMap = []
        let archivosDomicilioFiscalMap = []
        let archivosPrediosMap = []
        let archivosViverosMap = []
        let archivosMarcasMap = []
        let archivosMarcasBebidasMap = []
        let archivosInstalacionesMap = []
        let archivosInstalacionesResponsablesMap = []
        let archivosResponsablesInstMap = []
        //Archivos para actualizar
        let archivosRepresentanteLegal = []
        let archivosPersonasAutorizadas = []
        let archivosDomicilioFiscal = []
        let archivosPredios = []
        let archivosViveros = []
        let archivosMarcas = []
        let archivosMarcasBebidas = []
        let archivosInstalaciones = []
        let archivosInstalacionesResponsables = []
        let archivosResponsablesInst = []

        for (const anexo in rowspaginaDoc) {
            let nameid = rowspaginaDoc[anexo]?.nameid
            if (nameid !== undefined) {
                if ((nameid).includes('DGIOVAP') || (nameid).includes('DGPNAP') ||
                    rowspaginaDoc[anexo]?.nameid.includes('DGDBAP')) {
                    archivosRepresentanteLegalMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivoresponsablelegal: rowspaginaDoc[anexo]?.idfc_36archivoresponsablelegal,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosRepresentanteLegal.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivoresponsablelegal: rowspaginaDoc[anexo]?.idfc_36archivoresponsablelegal
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('DGIOVAUT') || rowspaginaDoc[anexo]?.nameid.includes('DGIOVAUTB')) {
                    archivosPersonasAutorizadasMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivopersonasautorizadas: rowspaginaDoc[anexo]?.idfc_36archivopersonasautorizadas,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosPersonasAutorizadas.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivopersonasautorizadas: rowspaginaDoc[anexo]?.idfc_36archivopersonasautorizadas
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('DGCSF') || rowspaginaDoc[anexo]?.nameid.includes('DGCD')) {
                    archivosDomicilioFiscalMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivodomiciliosfiscales: rowspaginaDoc[anexo]?.idfc_36archivodomiciliosfiscales,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosDomicilioFiscal.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivodomiciliosfiscales: rowspaginaDoc[anexo]?.idfc_36archivodomiciliosfiscales
                    })

                }
                if (rowspaginaDoc[anexo]?.nameid.includes('COPIAESCPRED') || rowspaginaDoc[anexo]?.nameid.includes('CONSPOSPRED') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CONARRENPRED') || rowspaginaDoc[anexo]?.nameid.includes('IOVARRENPRED') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVCOMPRPRED') || rowspaginaDoc[anexo]?.nameid.includes('CONCOMPRPRED') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CONCOMODAPRED') || rowspaginaDoc[anexo]?.nameid.includes('IOVCOMTEPRED') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVCOMRIOPRED')) {
                    archivosPrediosMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivopredio: rowspaginaDoc[anexo]?.idfc_36archivopredio,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosPredios.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivopredio: rowspaginaDoc[anexo]?.idfc_36archivopredio
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('COPIAESCVIV') || rowspaginaDoc[anexo]?.nameid.includes('CONSPOSVIV') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CONARRENVIV') || rowspaginaDoc[anexo]?.nameid.includes('IOVARRENVIV') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVCOMPRVIV') || rowspaginaDoc[anexo]?.nameid.includes('CONCOMPRVIV') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CONCOMODAVIV') || rowspaginaDoc[anexo]?.nameid.includes('IOVCOMTEVIV') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVCOMRIOVIV')) {
                    archivosViverosMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivovivero: rowspaginaDoc[anexo]?.idfc_36archivovivero,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosViveros.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivovivero: rowspaginaDoc[anexo]?.idfc_36archivovivero
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('TITULOMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('LICAUTMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CESAUTMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('LICTMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRLTMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CESMTMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRCDMTMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CMMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRMTMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CRMLTMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CESTMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CRMCTMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('JEMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('MARCAMEZCALCONVENIO') ||
                    rowspaginaDoc[anexo]?.nameid.includes('MARCAMEZCALCONTRATO')) {
                    archivosMarcasMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idarchivosmarca: rowspaginaDoc[anexo]?.idarchivosmarca,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosMarcas.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idarchivosmarca: rowspaginaDoc[anexo]?.idarchivosmarca
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('TITULOMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('LICAUTMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CESAUTMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('LICTMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRLTMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CESMTMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRCDMTMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CMMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRMTMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CRMLTMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CESTMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CRMCTMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('JEMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('MARCACONMEZCALCONVENIO') ||
                    rowspaginaDoc[anexo]?.nameid.includes('MARCACONMEZCALCONTRATO')) {
                    archivosMarcasBebidasMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idarchivosmarcaproducto: rowspaginaDoc[anexo]?.idarchivosmarcaproducto,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosMarcasBebidas.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idarchivosmarcaproducto: rowspaginaDoc[anexo]?.idarchivosmarcaproducto
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('TITULOINS') || rowspaginaDoc[anexo]?.nameid.includes('CAINSP') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CAINS') || rowspaginaDoc[anexo]?.nameid.includes('IOVRINS') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVOINS') || rowspaginaDoc[anexo]?.nameid.includes('CCINSP') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CCINS') || rowspaginaDoc[anexo]?.nameid.includes('IOVEINS') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVOINS')) {
                    archivosInstalacionesMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idarchivosinstalacion: rowspaginaDoc[anexo]?.idarchivosinstalacion,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosInstalaciones.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idarchivosinstalacion: rowspaginaDoc[anexo]?.idarchivosinstalacion
                    })
                }

                if (rowspaginaDoc[anexo]?.nameid.includes('ACTINSTREP')) {
                    archivosResponsablesInstMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivoresponsables: rowspaginaDoc[anexo]?.idfc_36archivoresponsables,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosResponsablesInst.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivoresponsables: rowspaginaDoc[anexo]?.idfc_36archivoresponsables
                    })
                } else {
                    if (rowspaginaDoc[anexo]?.nameid.includes('INSTREP')) {
                        archivosInstalacionesResponsablesMap.push({
                            estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                            idarchivosresponsables: rowspaginaDoc[anexo]?.idarchivosresponsables,
                        })
                        let fechaInicio = ''
                        let fechaFin = ''
                        if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                        else fechaInicio = null
                        if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                        else fechaFin = null
                        archivosInstalacionesResponsables.push({
                            fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                            idarchivosresponsables: rowspaginaDoc[anexo]?.idarchivosresponsables
                        })
                    }
                }
            }
        }

        let formato = {
            solicitud: principal,
            archivosRepresentanteLegal, archivosPersonasAutorizadas, archivosDomicilioFiscal, archivosPredios, archivosViveros,
            archivosMarcas, archivosMarcasBebidas, archivosInstalaciones, archivosInstalacionesResponsables,
            archivosResponsablesInst
        }
        let formatoMap = {
            solicitud: principalMap, mediosContactoMap, representantesLegalesMap, personasAutorizadasMap, domiciliosFiscalesMap,
            prediosMap, viveroMap, marcasMap, marcasBebidasMap, InstalacionesDomicilioMap, InstalacionesResponsablesMap,
            archivosRepresentanteLegalMap, archivosPersonasAutorizadasMap, archivosDomicilioFiscalMap, archivosPrediosMap, archivosViverosMap,
            archivosMarcasMap, archivosMarcasBebidasMap, archivosInstalacionesMap, archivosInstalacionesResponsablesMap,
            ResponsablesInstMap, archivosResponsablesInstMap
        }
        await dispatch(agregarMapFC_36Accion(formatoMap))
        await dispatch(actualizarFC_36Solicitud(formato))
        return
    }




    const actualizarMapYActualizarFC_36 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        /*principal.push({
            idfc41_solicitudparabebidasconm: rowspagina1[0].idfc41_solicitudparabebidasconm,
            responsableinstalaciones: rowspagina1[1].valor,
            correoelectronico: rowspagina1[2].valor, telefono: rowspagina1[3].valor,
            domicilio: rowspagina1[4].valor, fechasolicitud: fechaSolicitudAceptada
        })*/
        let principalMap = []
        if (solicitud.cambiorazon) {
            await principalMap.push({
                cambiorazon: rowspaginaGeneral[0].observaciones,
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                medioscontacto: '',

                cambiorazoncheck: rowspaginaGeneral[0].incorrecto,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                idfc36_solicitudactualizacionmap: fc_36Map.idfc36_solicitudactualizacionmap,
            })
        } else {
            if (solicitud.actualizacioninstalaciones) await principalMap.push({
                actualizacioninstalaciones: rowspaginaGeneral[0].observaciones,
                actualizacioninstalacionescheck: rowspaginaGeneral[0].incorrecto,
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioncadena: '',
                actualizacioncadenacheck: false,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                idfc36_solicitudactualizacionmap: fc_36Map.idfc36_solicitudactualizacionmap,
                cambiorazon: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.actualizacionprediosviveros) await principalMap.push({
                actualizacionprediosviveros: rowspaginaGeneral[0].observaciones,
                actualizacionprediosviveroscheck: rowspaginaGeneral[0].incorrecto,
                actualizacioncadena: '',
                actualizacioncadenacheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                idfc36_solicitudactualizacionmap: fc_36Map.idfc36_solicitudactualizacionmap,
                cambiorazon: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.actualizacioncadena) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                actualizacioncadena: rowspaginaGeneral[0].observaciones,
                actualizacioncadenacheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                idfc36_solicitudactualizacionmap: fc_36Map.idfc36_solicitudactualizacionmap,
                cambiorazon: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.actualizaciondomicilio) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                actualizaciondomicilio: rowspaginaGeneral[0].observaciones,
                actualizaciondomiciliocheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                idfc36_solicitudactualizacionmap: fc_36Map.idfc36_solicitudactualizacionmap,
                cambiorazon: '',
                actualizacioncadena: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.cambioresponsable) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                cambioresponsable: rowspaginaGeneral[0].observaciones,
                cambioresponsablecheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                idfc36_solicitudactualizacionmap: fc_36Map.idfc36_solicitudactualizacionmap,
                cambiorazon: '',
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambiorepresentante: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambiorepresentantecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.cambiorepresentante) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                cambiorepresentante: rowspaginaGeneral[0].observaciones,
                cambiorepresentantecheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                idfc36_solicitudactualizacionmap: fc_36Map.idfc36_solicitudactualizacionmap,
                cambiorazon: '',
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                medioscontacto: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                medioscontactocheck: false,
            })
            if (solicitud.actualizarmedioscontacto) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                medioscontacto: rowspaginaGeneral[0].observaciones,
                medioscontactocheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                idfc36_solicitudactualizacionmap: fc_36Map.idfc36_solicitudactualizacionmap,
                cambiorazon: '',
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
            })
            if (solicitud.cambioresponsableinst) await principalMap.push({
                cambioresponsableinst: rowspaginaGeneral[0].observaciones,
                cambioresponsableinstcheck: rowspaginaGeneral[0].incorrecto,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                idfc36_solicitudactualizacionmap: fc_36Map.idfc36_solicitudactualizacionmap,
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                medioscontacto: '',
                medioscontactocheck: false,
                cambiorazon: '',
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
            })
            if (solicitud.actualizarmarcas) await principalMap.push({
                actualizacionprediosviveros: '',
                actualizacionprediosviveroscheck: false,
                actualizacioninstalaciones: '',
                actualizacioninstalacionescheck: false,
                otro: rowspaginaGeneral[0].observaciones,
                otrocheck: rowspaginaGeneral[0].incorrecto,
                cambioresponsableinst: '',
                cambioresponsableinstcheck: false,
                idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion,
                idfc36_solicitudactualizacionmap: fc_36Map.idfc36_solicitudactualizacionmap,
                medioscontacto: '',
                medioscontactocheck: false,
                cambiorazon: '',
                actualizacioncadena: '',
                actualizaciondomicilio: '',
                cambioresponsable: '',
                cambiorepresentante: '',
                cambiorazoncheck: false,
                actualizacioncadenacheck: false,
                actualizaciondomiciliocheck: false,
                cambioresponsablecheck: false,
                cambiorepresentantecheck: false,
            })
        }
        /*for (const i in rowspagina1) {
            if (rowspagina1?.[i].Campo === 'Entrega de hologramas para bebidas con mezcal') principalMap.push({ entregahologramasbebidasmezcal: rowspagina1[i].observaciones, entregahologramasbebidasmezcalcheck: rowspagina1[i].incorrecto })
        }
        let obj_unidos = {}
        for (const i in principalMap) {
            obj_unidos = Object.assign(obj_unidos, principalMap[i])
        }*/
        let mediosContactoMap = []
        for (const i in rowspagina1) {
            mediosContactoMap.push({
                observacion: rowspagina1?.[i]?.observaciones, validacioncheck: rowspagina1?.[i]?.incorrecto,
                idfc36_anexomediodecontacto: rowspagina1?.[i]?.idfc36_anexomediodecontacto,
                idfc36_anexomediodecontactomap: rowspagina1?.[i]?.idfc36_anexomediodecontactomap
            })
        }
        let personasAutorizadasMap = []
        for (const i in rowspagina2) {
            personasAutorizadasMap.push({
                observacion: rowspagina2?.[i]?.observaciones, validacioncheck: rowspagina2?.[i]?.incorrecto,
                idfc36_anexopersonasautorizadas: rowspagina2?.[i]?.idfc36_anexopersonasautorizadas,
                idfc36_anexopersonasautorizadasmap: rowspagina2?.[i]?.idfc36_anexopersonasautorizadasmap
            })
        }
        let representantesLegalesMap = []
        for (const i in rowspagina3) {
            representantesLegalesMap.push({
                observacion: rowspagina3?.[i]?.observaciones, validacioncheck: rowspagina3?.[i]?.incorrecto,
                idfc36_anexoapoderadoslegales: rowspagina3?.[i]?.idfc36_anexoapoderadoslegales,
                idfc36_anexoapoderadoslegalesmap: rowspagina3?.[i]?.idfc36_anexoapoderadoslegalesmap
            })
        }
        let domiciliosFiscalesMap = []
        for (const i in rowspaginaDomiclio) {
            domiciliosFiscalesMap.push({
                observacion: rowspaginaDomiclio?.[i]?.observaciones, validacioncheck: rowspaginaDomiclio?.[i]?.incorrecto,
                idfc36_anexodomiciliosfiscales: rowspaginaDomiclio?.[i]?.idfc36_anexodomiciliosfiscales,
                idfc36_anexodomiciliosfiscalesmap: rowspaginaDomiclio?.[i]?.idfc36_anexodomiciliosfiscalesmap
            })
        }
        let prediosMap = []
        for (const i in rowsPredio) {
            prediosMap.push({
                observacion: rowsPredio?.[i]?.observaciones, validacioncheck: rowsPredio?.[i]?.incorrecto,
                idfc36_anexopredio: rowsPredio?.[i]?.idfc36_anexopredio, idfc36_anexoprediomap: rowsPredio?.[i]?.idfc36_anexoprediomap
            })
        }
        let viveroMap = []
        for (const i in rowsVivero) {
            viveroMap.push({
                observacion: rowsVivero?.[i]?.observaciones, validacioncheck: rowsVivero?.[i]?.incorrecto,
                idfc_36_anexoviveros: rowsVivero?.[i]?.idfc_36_anexoviveros, idfc_36_anexoviverosmap: rowsVivero?.[i]?.idfc_36_anexoviverosmap
            })
        }
        let marcasMap = []
        for (const i in rowsMarcas) {
            marcasMap.push({
                observacion: rowsMarcas?.[i]?.observaciones, validacioncheck: rowsMarcas?.[i]?.incorrecto,
                idfc36_anexomarcas: rowsMarcas?.[i]?.idfc36_anexomarcas, idfc36_anexomarcasmap: rowsMarcas?.[i]?.idMap
            })
        }
        let marcasBebidasMap = []
        for (const i in rowsMarcasBebidas) {
            marcasBebidasMap.push({
                observacion: rowsMarcasBebidas?.[i]?.observaciones, validacioncheck: rowsMarcasBebidas?.[i]?.incorrecto,
                idfc36_anexomarcasproductoconmezcal: rowsMarcasBebidas?.[i]?.idfc36_anexomarcasproductoconmezcal,
                idfc36_anexomarcasproductoconmezcalmap: rowsMarcasBebidas?.[i]?.idMap
            })
        }
        let ResponsablesInstMap = []
        for (const i in rowsResponsablesInst) {
            ResponsablesInstMap.push({
                observacion: rowsResponsablesInst?.[i]?.observaciones, validacioncheck: rowsResponsablesInst?.[i]?.incorrecto,
                idfc_36_actulizarresponsableinstalaciones: rowsResponsablesInst?.[i]?.idfc_36_actulizarresponsableinstalaciones,
                idfc_36_actulizarresponsableinstalacionesmap: rowsResponsablesInst?.[i]?.idMap
            })
        }
        let InstalacionesDomicilioMap = []
        let InstalacionesResponsablesMap = []
        for (const i in rowsInstalaciones) {
            if (rowsInstalaciones[i].Campo === 'Domicilio de instalación') InstalacionesDomicilioMap.push({
                observacion: rowsInstalaciones?.[i]?.observaciones,
                validacioncheck: rowsInstalaciones?.[i]?.incorrecto, idfc_36informaciongeneral: rowsInstalaciones?.[i]?.idfc_36informaciongeneral,
                idfc_36informaciongeneralmap: rowsInstalaciones?.[i]?.idfc_36informaciongeneralmap
            })
            if (rowsInstalaciones[i].Campo === 'Nombre del responsable') InstalacionesResponsablesMap.push({
                observacion: rowsInstalaciones?.[i]?.observaciones, validacioncheck: rowsInstalaciones?.[i]?.incorrecto,
                idfc_36responsabledeinstalacion: rowsInstalaciones?.[i]?.idfc_36responsabledeinstalacion,
                idfc_36responsabledeinstalacionmap: rowsInstalaciones?.[i]?.idfc_36responsabledeinstalacionmap
            })

        }
        //Archivos para map
        let archivosRepresentanteLegalMap = []
        let archivosPersonasAutorizadasMap = []
        let archivosDomicilioFiscalMap = []
        let archivosPrediosMap = []
        let archivosViverosMap = []
        let archivosMarcasMap = []
        let archivosMarcasBebidasMap = []
        let archivosInstalacionesMap = []
        let archivosInstalacionesResponsablesMap = []
        let archivosResponsablesInstMap = []
        //Archivos para actualizar
        let archivosRepresentanteLegal = []
        let archivosPersonasAutorizadas = []
        let archivosDomicilioFiscal = []
        let archivosPredios = []
        let archivosViveros = []
        let archivosMarcas = []
        let archivosMarcasBebidas = []
        let archivosInstalaciones = []
        let archivosInstalacionesResponsables = []
        let archivosResponsablesInst = []

        for (const anexo in rowspaginaDoc) {
            let nameid = rowspaginaDoc[anexo]?.nameid
            if (nameid !== undefined) {
                if ((nameid).includes('DGIOVAP') || (nameid).includes('DGPNAP') ||
                    rowspaginaDoc[anexo]?.nameid.includes('DGDBAP')) {
                    archivosRepresentanteLegalMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivoresponsablelegal: rowspaginaDoc[anexo]?.idfc_36archivoresponsablelegal,
                        idfc_36archivoresponsablelegalmap: rowspaginaDoc[anexo]?.idMap
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosRepresentanteLegal.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivoresponsablelegal: rowspaginaDoc[anexo]?.idfc_36archivoresponsablelegal
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('DGIOVAUT') || rowspaginaDoc[anexo]?.nameid.includes('DGIOVAUTB')) {
                    archivosPersonasAutorizadasMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivopersonasautorizadas: rowspaginaDoc[anexo]?.idfc_36archivopersonasautorizadas,
                        idfc_36archivopersonasautorizadasmap: rowspaginaDoc[anexo]?.idMap,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosPersonasAutorizadas.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivopersonasautorizadas: rowspaginaDoc[anexo]?.idfc_36archivopersonasautorizadas
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('DGCSF') || rowspaginaDoc[anexo]?.nameid.includes('DGCD')) {
                    archivosDomicilioFiscalMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivodomiciliosfiscales: rowspaginaDoc[anexo]?.idfc_36archivodomiciliosfiscales,
                        idfc_36archivodomiciliosfiscalesmap: rowspaginaDoc[anexo]?.idMap,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosDomicilioFiscal.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivodomiciliosfiscales: rowspaginaDoc[anexo]?.idfc_36archivodomiciliosfiscales
                    })

                }
                if (rowspaginaDoc[anexo]?.nameid.includes('COPIAESCPRED') || rowspaginaDoc[anexo]?.nameid.includes('CONSPOSPRED') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CONARRENPRED') || rowspaginaDoc[anexo]?.nameid.includes('IOVARRENPRED') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVCOMPRPRED') || rowspaginaDoc[anexo]?.nameid.includes('CONCOMPRPRED') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CONCOMODAPRED') || rowspaginaDoc[anexo]?.nameid.includes('IOVCOMTEPRED') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVCOMRIOPRED')) {
                    archivosPrediosMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivopredio: rowspaginaDoc[anexo]?.idfc_36archivopredio,
                        idfc_36archivoprediomap: rowspaginaDoc[anexo]?.idMap,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosPredios.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivopredio: rowspaginaDoc[anexo]?.idfc_36archivopredio
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('COPIAESCVIV') || rowspaginaDoc[anexo]?.nameid.includes('CONSPOSVIV') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CONARRENVIV') || rowspaginaDoc[anexo]?.nameid.includes('IOVARRENVIV') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVCOMPRVIV') || rowspaginaDoc[anexo]?.nameid.includes('CONCOMPRVIV') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CONCOMODAVIV') || rowspaginaDoc[anexo]?.nameid.includes('IOVCOMTEVIV') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVCOMRIOVIV')) {
                    archivosViverosMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivovivero: rowspaginaDoc[anexo]?.idfc_36archivovivero,
                        idfc_36archivoviveromap: rowspaginaDoc[anexo]?.idMap,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosViveros.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivovivero: rowspaginaDoc[anexo]?.idfc_36archivovivero
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('TITULOMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('LICAUTMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CESAUTMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('LICTMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRLTMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CESMTMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRCDMTMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CMMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRMTMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CRMLTMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CESTMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CRMCTMARCAMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('JEMARCAMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('MARCAMEZCALCONVENIO') ||
                    rowspaginaDoc[anexo]?.nameid.includes('MARCAMEZCALCONTRATO')) {
                    archivosMarcasMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idarchivosmarca: rowspaginaDoc[anexo]?.idarchivosmarca, idarchivosmarcamap: rowspaginaDoc[anexo]?.idMap,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosMarcas.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idarchivosmarca: rowspaginaDoc[anexo]?.idarchivosmarca
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('TITULOMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('LICAUTMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CESAUTMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('LICTMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRLTMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CESMTMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRCDMTMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CMMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CRMTMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CRMLTMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CESTMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('CRMCTMARCACONMEZCAL') ||
                    rowspaginaDoc[anexo]?.nameid.includes('JEMARCACONMEZCAL') || rowspaginaDoc[anexo]?.nameid.includes('MARCACONMEZCALCONVENIO') ||
                    rowspaginaDoc[anexo]?.nameid.includes('MARCACONMEZCALCONTRATO')) {
                    archivosMarcasBebidasMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idarchivosmarcaproducto: rowspaginaDoc[anexo]?.idarchivosmarcaproducto, idarchivosmarcaproductomap: rowspaginaDoc[anexo]?.idMap,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosMarcasBebidas.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idarchivosmarcaproducto: rowspaginaDoc[anexo]?.idarchivosmarcaproducto
                    })
                }
                if (rowspaginaDoc[anexo]?.nameid.includes('TITULOINS') || rowspaginaDoc[anexo]?.nameid.includes('CAINSP') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CAINS') || rowspaginaDoc[anexo]?.nameid.includes('IOVRINS') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVOINS') || rowspaginaDoc[anexo]?.nameid.includes('CCINSP') ||
                    rowspaginaDoc[anexo]?.nameid.includes('CCINS') || rowspaginaDoc[anexo]?.nameid.includes('IOVEINS') ||
                    rowspaginaDoc[anexo]?.nameid.includes('IOVOINS')) {
                    archivosInstalacionesMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idarchivosinstalacion: rowspaginaDoc[anexo]?.idarchivosinstalacion,
                        idarchivosinstalacionmap: rowspaginaDoc[anexo]?.idMap,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosInstalaciones.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idarchivosinstalacion: rowspaginaDoc[anexo]?.idarchivosinstalacion
                    })
                }

                if (rowspaginaDoc[anexo]?.nameid.includes('ACTINSTREP')) {
                    archivosResponsablesInstMap.push({
                        estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                        idfc_36archivoresponsables: rowspaginaDoc[anexo]?.idfc_36archivoresponsables,
                        idfc_36archivoresponsablesmap: rowspaginaDoc[anexo]?.idMap,
                    })
                    let fechaInicio = ''
                    let fechaFin = ''
                    if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                    else fechaInicio = null
                    if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                    else fechaFin = null
                    archivosResponsablesInst.push({
                        fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                        idfc_36archivoresponsables: rowspaginaDoc[anexo]?.idfc_36archivoresponsables
                    })
                } else {
                    if (rowspaginaDoc[anexo]?.nameid.includes('INSTREP')) {
                        archivosInstalacionesResponsablesMap.push({
                            estatuscheck: rowspaginaDoc[anexo]?.incorrecto, observacion: rowspaginaDoc[anexo]?.observaciones,
                            idarchivosresponsables: rowspaginaDoc[anexo]?.idarchivosresponsables,
                            idarchivosresponsablesmap: rowspaginaDoc[anexo]?.idMap,
                        })
                        let fechaInicio = ''
                        let fechaFin = ''
                        if (rowspaginaDoc[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspaginaDoc[anexo]?.fechaInicio).toISOString()
                        else fechaInicio = null
                        if (rowspaginaDoc[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspaginaDoc[anexo]?.fechaTermino).toISOString()
                        else fechaFin = null
                        archivosInstalacionesResponsables.push({
                            fechainicio: fechaInicio, fechafin: fechaFin, estatus: rowspaginaDoc[anexo]?.estatus,
                            idarchivosresponsables: rowspaginaDoc[anexo]?.idarchivosresponsables
                        })
                    }
                }
            }
        }

        let formato = {
            solicitud: principal,
            archivosRepresentanteLegal, archivosPersonasAutorizadas, archivosDomicilioFiscal, archivosPredios, archivosViveros,
            archivosMarcas, archivosMarcasBebidas, archivosInstalaciones, archivosInstalacionesResponsables,
            archivosResponsablesInst
        }
        let formatoMap = {
            solicitud: principalMap, mediosContactoMap, representantesLegalesMap, personasAutorizadasMap, domiciliosFiscalesMap,
            prediosMap, viveroMap, marcasMap, marcasBebidasMap, InstalacionesDomicilioMap, InstalacionesResponsablesMap,
            archivosRepresentanteLegalMap, archivosPersonasAutorizadasMap, archivosDomicilioFiscalMap, archivosPrediosMap, archivosViverosMap,
            archivosMarcasMap, archivosMarcasBebidasMap, archivosInstalacionesMap, archivosInstalacionesResponsablesMap,
            ResponsablesInstMap, archivosResponsablesInstMap
        }
        await dispatch(actualizarMapFC_36Accion(formatoMap))
        await dispatch(actualizarFC_36Solicitud(formato))
        return
    }

    const [formatosResponsable, setFormatosResponsable] = React.useState(false);
    const [formatosResponsableAlta, setFormatosResponsableAlta] = React.useState(false);
    const [domiciliosFiscales, setDomiciliosFsicales] = React.useState(false);


    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);


    const botonAceptarModal = async () => {
        //
        let filtro = rowspaginaDomiclio?.filter(anexo => anexo?.domicilioprincipal == true)
        let domicilioFiscal = filtro?.[0]?.domicilio?.split(',')
        let razonSocial = ''
        if (solicitud.cambiorazon) razonSocial = solicitud.actualizacionnombrerazon
        else razonSocial = solicitud.nombrerazonsocial
        let filtroResponsable = rowspagina3.filter(anexo => anexo.baja === null)
        let filtroMedios = rowspagina1.filter(anexo => anexo.isbaja == false && anexo.baja == false)
        let telefonos = ''
        for (const i in filtroMedios) {
            if (Number(Number(i) + 1) == filtroMedios.length) {
                telefonos += filtroMedios[i].telefono
            } else {
                if (Number(i) == 3) {
                    break
                } else {
                    if (Number(i) + 1 != 3) {
                        telefonos += filtroMedios[i].telefono + ','
                    } else {
                        telefonos += filtroMedios[i].telefono
                    }
                }
            }
        }
        const dataFomulario = {
            //regimenfiscal: solicitud.personafisica === true ? 'Persona fisica' : 'Persona moral',
            calle: domicilioFiscal?.[0], numerointerior: domicilioFiscal?.[1] !== null ? domicilioFiscal?.[1] : '', numeroexterior: domicilioFiscal?.[2] !== null ? domicilioFiscal?.[2] : '',
            colonia: domicilioFiscal?.[3], localidad: domicilioFiscal?.[4], municipio: domicilioFiscal?.[5],
            estado: domicilioFiscal?.[6], codigopostal: domicilioFiscal?.[7],
            viverista: solicitud.viverista, productormaguey: solicitud.productormaguey,
            productormezcal: solicitud.productormezcal, envasador: solicitud.envasador,
            comercializadormezcal: solicitud.comercializadormezcal, comercializadorbebidasconmezcal: solicitud.comercializadorbebidasconmezcal,
            razonsocial: razonSocial, telefono: telefonos, correoelectronico: filtroMedios?.[0]?.correoelectronico,
            representantelegal: filtroResponsable?.[0]?.representantelegal, passwordNom: true, solicitud: solicitud
        }

        if (solicitud.cambioresponsable) {
            let filtroResBaja = solicitud.fc_36_anexoapoderadoslegales.filter(anexo => anexo.principal == true && anexo.baja == true)
            if (filtroResBaja.length == 0) setFormatosResponsable(true)
            let filtroResAlta = solicitud.fc_36_anexoapoderadoslegales.filter(anexo => anexo.principal == true && anexo.alta == true)
            if (filtroResAlta.length > 0) setFormatosResponsableAlta(true)
        }
        if (solicitud.actualizaciondomicilio) {
            let filtroDomicilio = solicitud.fc_36_anexodomiciliosfiscales.filter(anexo => anexo.baja == true && anexo.domicilioprincipal == true)
            if (filtroDomicilio.length > 0) setDomiciliosFsicales(true)
        }

        let hacerFormatos = false

        if (!solicitud.actualizacioncadena) {
            for (const i in rowsInstalaciones) {
                if (rowsInstalaciones[i].Campo == "Domicilio de instalación") {
                    if (rowsInstalaciones[i].alta || rowsInstalaciones[i].baja || rowsInstalaciones[i].isedicion) {
                        hacerFormatos = true
                        break
                    }
                }
            }
            for (const datos in rowsMarcas) {
                if (rowsMarcas[Number(datos)]?.relacioncontacto == null || rowsMarcas[Number(datos)]?.relacioncontacto == undefined) {
                    hacerFormatos = true
                    break
                }
            }
            for (const datos in rowsMarcasBebidas) {
                if (rowsMarcasBebidas[Number(datos)]?.relacioncontacto == null || rowsMarcasBebidas[Number(datos)]?.relacioncontacto == undefined) {
                    hacerFormatos = true
                    break
                }
            }
            for (const datos in rowsPredio) {
                if (rowsPredio[Number(datos)]?.relacioncontacto == null || rowsPredio[Number(datos)]?.relacioncontacto == undefined) {
                    hacerFormatos = true
                    break
                }
            }
            for (const datos in rowsVivero) {
                if (rowsVivero[Number(datos)]?.relacioncontacto == null || rowsVivero[Number(datos)]?.relacioncontacto == undefined) {
                    hacerFormatos = true
                    break
                }
            }
        } else {
            if ((solicitud.viveristaaltabaja || solicitud.productormagueyaltabaja) ||
                (solicitud.productormezcalalta && !solicitud.productormezcal) ||
                (!solicitud.envasador && solicitud.envasadoraltabaja) ||
                (!solicitud.comercializadormezcal || solicitud.comercializadormezcalaltabaja) ||
                (!solicitud.comercializadorbebidas || solicitud.comercializadorbebidasaltabaja)) hacerFormatos = false
            else hacerFormatos = hacerFormatos = true
        }
        if (solicitud.actualizacioncadena) {
            for (const i in rowsInstalaciones) {
                if (rowsInstalaciones[i].Campo == "Domicilio de instalación") {
                    if (rowsInstalaciones[i].alta || rowsInstalaciones[i].baja || rowsInstalaciones[i].isedicion) {
                        hacerFormatos = true
                        break
                    }
                }
            }
        }
        if (solicitud?.actualizaciondomicilio) hacerFormatos = true
        dataFomulario.hacerFormatos = hacerFormatos
        setDataModal(dataFomulario)
        handleOpenModalAceptar()
    }
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    {(solicitud.actualizarmedioscontacto || solicitud.cambiorepresentante || solicitud.cambioresponsableinst ||
                        solicitud.actualizarmarcas || solicitud.actualizacionprediosviveros || (formatosResponsable && !formatosResponsableAlta) ||
                        (!domiciliosFiscales && solicitud.actualizaciondomicilio)) && !solicitud.actualizacioncadena && !solicitud?.actualizaciondomicilio /*||
                        (solicitud.actualizacioncadena && (solicitud.viveristaaltabaja || solicitud.productormagueyaltabaja ||
                            solicitud.comercializadorbebidasaltabaja || solicitud.comercializadormezcalaltabaja) && 
                            (!solicitud.productormezcalaltabaja && !solicitud.envasadoraltabaja))*/ ?
                        <Box sx={styleParaAceptar}>
                            <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                                <strong>Aceptar Solicitud</strong>
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'justify' }}>
                                Está a punto de aceptar la solicitud, ya no podrá seguir revisándola
                                y los datos se tomarán como válidos.
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'center' }}>
                                <strong>¿Desea continuar?</strong>
                            </Typography>
                            <div className='row'>
                                <button className='btn btn-success' onClick={() => botonContinuar()}>CONTINUAR</button>
                            </div>
                            <br />
                        </Box> :
                        <Box sx={styleParaModalDeDocumentos}>

                            <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                                Para finalizar el trámite ingrese los siguientes datos
                            </Typography>
                            <FormularioDocumentacion
                                data={dataModal}
                                functionAcept={botonContinuar}
                            ></FormularioDocumentacion>
                            <br />
                        </Box>
                    }

                </Modal>
            </div>

        )
    }
    const botonContinuar = async (dataForm) => {

        await dispatch(actualizarLoadingApp_true())
        if (solicitud.fc_36_solicituddeactualizacionmap.length === 0) await agregarMapYActualizarFC_36()
        else await actualizarMapYActualizarFC_36()
        let dataMetricas = {
            estatus_procedencia: "Solicitudes Recibidas Procedentes",
            id_solicitud: "11", id_usuario: dataUser?.[0].idlogin,
            motivo: "Cargado automatico del sistema",
            fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
            numero_cliente: solicitud?.numerocliente,
            numero_solicitud: dataForm?.numeroSolicitud, origen: "Sistema"
        }
        await dispatch(crearMetricas(dataMetricas))
        let idSolicitud = solicitud.idfc36_solicitudactualizacion
        let estatusNuevo = 4
        let resSolicitud = await dispatch(obtenerFC_36SolicitudDetalle(idSolicitud))
        let { ...solicitudParaAceptar } = resSolicitud.payload
        let idcliente = await dispatch(obtenerIdCliente(solicitudParaAceptar.idlogin))
        solicitudParaAceptar.idcliente = idcliente.payload.data.data?.[0].idcliente
        let idCliente = idcliente.payload.data.data?.[0].idcliente
        let resAceptar = await dispatch(aceptarSolicitud(solicitudParaAceptar))
        const detalle = await dispatch(obtenerClienteDetalle(idcliente.payload?.data?.data?.[0]?.idcliente))
        const solicitudPrincipal = detalle?.payload?.data?.data

        let informacionmodalaceptada = {
            numerocliente: solicitud?.numerocliente, tipoidentificacion: dataForm?.tipoDeIdentificacion,
            numeroidentificacion: dataForm?.numeroDeIdentificacion, emisionacreditacion: dataForm?.emisionDeAcreditacion,
            datosactaconstitutiva: dataForm?.datosDelActa, objetosocial: dataForm?.objetoSocial,
            contraseñanom: dataForm?.passwordNom,
            numerosolicitudservicios: dataForm?.numeroSolicitud, numcertificadonom: dataForm?.numCertificadoNOM,
            numerotraslado: dataForm?.numeroTraslado, otrosservicios: dataForm?.otrosServicios,
            fechainspeccion: dataForm?.fechaInspeccion,
            numeroplanevaluacion: dataForm?.numeroPlanEvaluacion,
            inspectorasignado: dataForm?.inspectorAsignado, credencialinspector: dataForm?.credencialInspector,
            telefonoinspector: dataForm?.telefonoInspector, poderNotarial: dataForm?.poderNotarial
        }
        let modal = { idfc36_solicitudactualizacion: solicitud.idfc36_solicitudactualizacion, informacionmodalaceptada: informacionmodalaceptada }
        await (dispatch(actualizarFC_36Formulario(modal)))

        await generarOficios(dataForm, solicitudParaAceptar, solicitudPrincipal)
        let filtroResbaja = solicitudParaAceptar.fc_36_anexoapoderadoslegales.filter(anexo => anexo.principal == true && anexo.baja == true)

        if (!solicitud.actualizarmedioscontacto && !solicitud.cambioresponsableinst && !solicitud.actualizarmarcas &&
            !solicitud.actualizacionprediosviveros && filtroResbaja.length > 0 || !domiciliosFiscales) {
            await enviarEmail(solicitudParaAceptar, solicitudParaAceptar.idfc36_solicitudactualizacion, dataForm)
        }
        const tablaFC_36 = 10
        const tabla = tablaFC_36
        await dispatch(actualizarFC_36Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idcliente.payload?.data?.data?.[0]?.idcliente, folio: solicitud.folio } }
        ))
        await dispatch(resetDataFC_36())

        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const enviarEmail = async (solicitudParaAceptar, idCliente, dataForm) => {
        //const result = await dispatch(obtenerLogin(solicitud.idlogin))

        //const correoLogin = result.data?.data?.usuario
        let tipoPersona = ''
        if (solicitudParaAceptar.tipoPersona == 'Fisica') tipoPersona = 'Fisica'
        else tipoPersona = 'Moral'
        let passwordNom = false
        if (dataForm != undefined || dataForm != null) {
            if (dataForm.passwordSi == true) passwordNom = true
            else passwordNom = false
        }

        let correos = ''
        for (const i in solicitudParaAceptar.fc_36_anexomediosdecontacto) {
            if (solicitudParaAceptar.fc_36_anexomediosdecontacto[i].isbaja != true && solicitudParaAceptar.fc_36_anexomediosdecontacto[i].baja != true) {
                if (i == 0) correos += solicitudParaAceptar.fc_36_anexomediosdecontacto[i].correoelectronico?.toLowerCase()
                else correos += ', ' + solicitudParaAceptar.fc_36_anexomediosdecontacto[i].correoelectronico?.toLowerCase()
            }
        }
        if (solicitudParaAceptar.actualizaciondomicilio && !solicitudParaAceptar.cambiorazon) {
            let empresa = ''
            if (solicitudParaAceptar.tipoempresa == 'moral') empresa = 'Moral'
            else empresa = 'Fisica'
            await dispatch(enviarCorreoContrato({ correosDest: correos, empresa, passwordNom, idCliente }))
        } else {
            if (!solicitudParaAceptar.cambioresponsableinst) {
                await dispatch(enviarCorreo({ correosDest: correos, tipoPersona, passwordNom, idCliente }))
            }
        }
    }
    const generarOficios = async (dataForm, solicitudParaAceptar, solicitudPrincipal) => {
        let tipoEmpresa = ''
        if (solicitudParaAceptar.cambiorazon === false || solicitudParaAceptar.cambiorazon === null || solicitudParaAceptar.cambiorazon === undefined) {
            if (solicitudPrincipal.personafisica) tipoEmpresa = 'Fisica'
            if (solicitudPrincipal.personamoral) tipoEmpresa = 'Moral'
        }
        if (solicitudParaAceptar.cambiorazon === true) {
            if (solicitudParaAceptar.tipoempresa === 'fisica') tipoEmpresa = 'Fisica'
            if (solicitudParaAceptar.tipoempresa === 'moral') tipoEmpresa = 'Moral'
        }
        if (tipoEmpresa === 'Fisica') {
            const tipoPersona = 'Fisica'
            let nombreRazonSocial = (solicitudPrincipal.nombrerazonsocial).toUpperCase()
            if (solicitudParaAceptar.cambiorazon == true) nombreRazonSocial = (solicitudParaAceptar.actualizacionnombrerazon).toUpperCase()
            if (solicitudParaAceptar.cambiorazon == false) nombreRazonSocial = (solicitudParaAceptar.nombrerazonsocial).toUpperCase()
            let cadenaProductiva = ''
            const arrayCadena = []
            if (solicitudParaAceptar.viverista) arrayCadena.push('viverista')
            if (solicitudParaAceptar.productormaguey) arrayCadena.push('Productor de maguey')
            if (solicitudParaAceptar.productormezcal) arrayCadena.push('Productor de mezcal')
            if (solicitudParaAceptar.envasador) arrayCadena.push('Envasador')
            if (solicitudParaAceptar.comercializadormezcal) arrayCadena.push('Comercializador de mezcal')
            if (solicitudParaAceptar.comercializadorbebidas) arrayCadena.push('Comercializador de productos con mezcal')
            if (arrayCadena.length > 1) {
                for (const i in arrayCadena) {
                    if (Number(i) === 0) {
                        cadenaProductiva += arrayCadena[i]
                    } else if (Number(i) + Number(1) === arrayCadena.length) {
                        cadenaProductiva += ' y ' + arrayCadena[i]
                    } else {
                        cadenaProductiva += ', ' + arrayCadena[i]
                    }
                }
            } else {
                cadenaProductiva = arrayCadena[0]
            }
            let domicilioFiscal = ''
            for (const i in solicitudParaAceptar.fc_36_anexodomiciliosfiscales) {
                let { ...domicilio } = solicitudParaAceptar.fc_36_anexodomiciliosfiscales[i]
                if (domicilio.domicilioprincipal == true) {
                    domicilioFiscal = domicilio.calle + ", " + domicilio.numerointerior + ', ' +
                        domicilio.numeroexterior + ', ' + domicilio.colonia + ', ' +
                        domicilio.localidad + ';' + domicilio.municipio + ', '
                        + domicilio.estado + ', C.P. ' + domicilio.codigopostal
                    break
                }
            }


            let telefonos = ''//solicitudPrincipal.telefono + " " + solicitudPrincipal.telefonorepresentante
            for (const i in solicitudParaAceptar.fc_36_anexomediosdecontacto) {
                if (solicitudParaAceptar.fc_36_anexomediosdecontacto?.[i]?.alta === true || (solicitudParaAceptar.fc_36_anexomediosdecontacto?.[i]?.relacioncontacto != null && solicitudParaAceptar.fc_36_anexomediosdecontacto?.[i]?.baja === false))
                    telefonos += ' ' + solicitudParaAceptar.fc_36_anexomediosdecontacto?.[i]?.telefono
            }

            let tipoIdentificacion = ''
            if (dataForm?.tipoDeIdentificacion === 'OTRO') {
                tipoIdentificacion = dataForm?.otroTipoDeIdentificacion
            } else {
                tipoIdentificacion = dataForm?.tipoDeIdentificacion
            }
            let activarCheckMarcario = false
            if (!solicitudParaAceptar.actualizacioncadena) {
                for (const i in solicitudParaAceptar.fc_36_anexomarcas) {
                    if (solicitudParaAceptar.fc_36_anexomarcas[i].isbaja === false) activarCheckMarcario = true
                }
                for (const i in solicitudParaAceptar.fc_36_anexomarcasproductoconmezcal) {
                    if (solicitudParaAceptar.fc_36_anexomarcasproductoconmezcal[i].isbaja === false) activarCheckMarcario = true
                }
            } else {
                if ((solicitudParaAceptar.comercializadorbebidas && solicitudParaAceptar.comercializadorbebidasaltabaja) ||
                    (solicitudParaAceptar.comercializadormezcal && solicitudParaAceptar.comercializadormezcalaltabaja)) {
                    for (const i in solicitudParaAceptar.fc_36_anexomarcas) {
                        if (solicitudParaAceptar.fc_36_anexomarcas[i].isbaja === false) activarCheckMarcario = true
                    }
                    for (const i in solicitudParaAceptar.fc_36_anexomarcasproductoconmezcal) {
                        if (solicitudParaAceptar.fc_36_anexomarcasproductoconmezcal[i].isbaja === false) activarCheckMarcario = true
                    }
                }
            }
            let datosInscripcion = ''
            if (solicitudParaAceptar.cambioresponsable) {
                let resultado = await dispatch(obtenerFC_01PorLoginMap(solicitudPrincipal.idlogin))
                if (resultado?.payload?.asociado) datosInscripcion = 'asociado'
                else if (resultado?.payload?.noasociado) datosInscripcion = 'no asociado'
            } else {
                if (solicitudParaAceptar.asociado) datosInscripcion = 'asociado'
                else if (solicitudParaAceptar.noasociado) datosInscripcion = 'no asociado'
            }

            const numeroIdentificacion = dataForm?.numeroDeIdentificacion
            const folioAsignacion = await dispatch(obtenerFolio(1))
            const data = {
                tipoSolicitud: 'FC_36',
                tipoPersona,
                nombreRazonSocial: nombreRazonSocial.toUpperCase(),
                cadenaProductiva: cadenaProductiva?.toUpperCase(),
                domicilioFiscal: domicilioFiscal.toUpperCase(),
                telefonos,
                tipoIdentificacion: tipoIdentificacion?.toUpperCase(),
                numeroIdentificacion,
                emisionDeAcreditacion: (dataForm?.emisionDeAcreditacion)?.toUpperCase(),
                nombrerepresentantelegal: solicitudPrincipal.nombrerepresentantelegal,
                folioAsignacion: folioAsignacion.payload.folio,
                solicitudParaAceptar, datosInscripcion,
                idCliente: solicitudParaAceptar.idcliente,
                oficioPassword: true,
                poderNotarial: dataForm?.poderNotarial
            }
            let folioPasswordNom = null
            if (data.oficioPassword) {
                data.password = (dataForm?.passwordNom)?.toUpperCase()
                data.passwordSi = dataForm?.passwordNomSi
                data.passwordNo = dataForm?.passwordNomNo
                folioPasswordNom = await dispatch(obtenerFolio(1))
                data.folioPasswordNom = folioPasswordNom.payload.folio
            }
            const dataSolicitudInspeccion = {
                numeroSolicitud: dataForm?.numeroSolicitud,
                telefonoEmpresa: solicitud.telefono,
                correoElectronicoEmpresa: solicitud?.correoelectronico,
                checkFabrica: false,
                checkProductor: false,
                checkNacional: false,
                checkEnvasadora: false,
                checkEnvasador: false,
                checkExportacion: false,
                checkGranel: false,
                checkComercializador: false,
                checkPromocion: false,
                checkProductoTerminado: false,
                checkTraslado: false,
                checkMaduracion: false,
                checkDitamenMarcario: activarCheckMarcario,
                numCertificadoNOM: dataForm?.numCertificadoNOM,
                numeroTraslado: dataForm?.numeroTraslado,
                otrosServicios: dataForm?.otrosServicios,
                fechaInspeccion: dataForm?.fechaInspeccion,
                instalaciones: solicitud.fc_36anexo,
                numeroPlanEvaluacion: dataForm?.numeroPlanEvaluacion,
                inspectorAsignado: dataForm?.inspectorAsignado,
                credencialInspector: dataForm?.credencialInspector,
                telefonoInspector: dataForm?.telefonoInspector,
            }
            /*dataSolicitudInspeccion.telefonoRepresentante = solicitud.telefonorepresentante
            dataSolicitudInspeccion.correoElectronicoRepresentante = solicitud.correoelectronicorepresentante*/
            // if(actividadCliente.comercializadormezcal || actividadCliente.comercializadorbebidasconmezcal) dataSolicitudInspeccion.checkDitamenMarcario = true, 
            data.dataSolicitudInspeccion = dataSolicitudInspeccion
            await dispatch(generarDocumentos(data))
        } else {
            const tipoPersona = 'Moral'
            let representanteLegal = (solicitudPrincipal.nombrerepresentantelegal).toUpperCase()
            let nombreRazonSocial = (solicitudPrincipal.nombrerazonsocial).toUpperCase()
            if (solicitudParaAceptar.cambiorazon == true) nombreRazonSocial = (solicitudParaAceptar.actualizacionnombrerazon).toUpperCase()
            if (solicitudParaAceptar.cambiorazon == false) nombreRazonSocial = (solicitudParaAceptar.nombrerazonsocial).toUpperCase()
            let cadenaProductiva = ''
            const arrayCadena = []
            if (solicitudParaAceptar.viverista) arrayCadena.push('viverista')
            if (solicitudParaAceptar.productormaguey) arrayCadena.push('Productor de maguey')
            if (solicitudParaAceptar.productormezcal) arrayCadena.push('Productor de mezcal')
            if (solicitudParaAceptar.envasador) arrayCadena.push('Envasador')
            if (solicitudParaAceptar.comercializadormezcal) arrayCadena.push('Comercializador de mezcal')
            if (solicitudParaAceptar.comercializadorbebidas) arrayCadena.push('Comercializador de productos con mezcal')
            if (arrayCadena.length > 1) {
                for (const i in arrayCadena) {
                    if (Number(i) === 0) {
                        cadenaProductiva += arrayCadena[i]
                    } else if (Number(i) + Number(1) === arrayCadena.length) {
                        cadenaProductiva += ' y ' + arrayCadena[i]
                    } else {
                        cadenaProductiva += ', ' + arrayCadena[i]
                    }
                }
            } else {
                cadenaProductiva = arrayCadena[0]
            }

            let domiciliosFiscales = solicitudParaAceptar.fc_36_anexodomiciliosfiscales?.[0]
            let domicilioFiscal = ''
            if (solicitudParaAceptar.fc_36_anexodomiciliosfiscales.length >= 2) {

                for (const i in solicitudParaAceptar.fc_36_anexodomiciliosfiscales) {
                    let { ...domicilio } = solicitudParaAceptar.fc_36_anexodomiciliosfiscales[i]
                    if (domicilio.domicilioprincipal == true) {
                        domicilioFiscal = domicilio.calle + ", " + domicilio.numerointerior + ', ' +
                            domicilio.numeroexterior + ', ' + domicilio.colonia + ', ' +
                            domicilio.localidad + ';' + domicilio.municipio + ', '
                            + domicilio.estado + ', C.P. ' + domicilio.codigopostal
                        break
                    }
                }
            } else {
                domicilioFiscal = domiciliosFiscales.calle + ", " + domiciliosFiscales.numerointerior + ', ' +
                    domiciliosFiscales.numeroexterior + ', ' + domiciliosFiscales.colonia + ', ' +
                    domiciliosFiscales.localidad + ';' + domiciliosFiscales.municipio + ', '
                    + domiciliosFiscales.estado + ', C.P. ' + domiciliosFiscales.codigopostal
            }

            let telefonos = ''//solicitudPrincipal.telefono + " " + solicitudPrincipal.telefonorepresentante
            for (const i in solicitudParaAceptar.fc_36_anexomediosdecontacto) {
                if (solicitudParaAceptar.fc_36_anexomediosdecontacto?.[i]?.alta === true || (solicitudParaAceptar.fc_36_anexomediosdecontacto?.[i]?.relacioncontacto != null && solicitudParaAceptar.fc_36_anexomediosdecontacto?.[i]?.baja === false))
                    telefonos += ' ' + solicitudParaAceptar.fc_36_anexomediosdecontacto?.[i]?.telefono
            }

            let tipoIdentificacion = ''
            if (dataForm?.tipoDeIdentificacion === 'OTRO') {
                tipoIdentificacion = dataForm?.otroTipoDeIdentificacion
            } else {
                tipoIdentificacion = dataForm?.tipoDeIdentificacion
            }
            const numeroIdentificacion = dataForm?.numeroDeIdentificacion
            let activarCheckMarcario = false
            if (!solicitudParaAceptar.actualizacioncadena) {
                for (const i in solicitudParaAceptar.fc_36_anexomarcas) {
                    if (solicitudParaAceptar.fc_36_anexomarcas[i].isbaja === false) activarCheckMarcario = true
                }
                for (const i in solicitudParaAceptar.fc_36_anexomarcasproductoconmezcal) {
                    if (solicitudParaAceptar.fc_36_anexomarcasproductoconmezcal[i].isbaja === false) activarCheckMarcario = true
                }
            } else {
                if ((solicitudParaAceptar.comercializadorbebidas && solicitudParaAceptar.comercializadorbebidasaltabaja) ||
                    (solicitudParaAceptar.comercializadormezcal && solicitudParaAceptar.comercializadormezcalaltabaja)) {
                    for (const i in solicitudParaAceptar.fc_36_anexomarcas) {
                        if (solicitudParaAceptar.fc_36_anexomarcas[i].isbaja === false) activarCheckMarcario = true
                    }
                    for (const i in solicitudParaAceptar.fc_36_anexomarcasproductoconmezcal) {
                        if (solicitudParaAceptar.fc_36_anexomarcasproductoconmezcal[i].isbaja === false) activarCheckMarcario = true
                    }
                }
            }
            const folioAsignacion = await dispatch(obtenerFolio(1))
            let datosInscripcion = ''
            if (solicitudParaAceptar.cambioresponsable) {
                let resultado = await dispatch(obtenerFC_01PorLoginMap(solicitudPrincipal.idlogin))
                if (resultado?.payload?.asociado) datosInscripcion = 'asociado'
                else if (resultado?.payload?.noasociado) datosInscripcion = 'no asociado'
            } else {
                if (solicitudParaAceptar.asociado) datosInscripcion = 'asociado'
                else if (solicitudParaAceptar.noasociado) datosInscripcion = 'no asociado'
            }

            const data = {
                tipoSolicitud: 'FC_36',
                tipoPersona,
                representanteLegal,
                nombreRazonSocial: nombreRazonSocial?.toUpperCase(),
                cadenaProductiva: cadenaProductiva?.toUpperCase(),
                domicilioFiscal: domicilioFiscal?.toUpperCase(),
                telefonos,
                tipoIdentificacion: tipoIdentificacion?.toUpperCase(),
                numeroIdentificacion,
                emisionDeAcreditacion: (dataForm?.emisionDeAcreditacion)?.toUpperCase(),
                objetoSocial: (dataForm?.objetoSocial)?.toUpperCase(),
                datosDelActa: (dataForm?.datosDelActa)?.toUpperCase(),
                folioAsignacion: folioAsignacion.payload.folio,
                solicitudParaAceptar, datosInscripcion,
                idCliente: solicitudParaAceptar.idcliente,
                oficioPassword: true,
                poderNotarial: dataForm?.poderNotarial
            }
            let folioPasswordNom = null
            if (data.oficioPassword) {
                data.password = (dataForm?.passwordNom)?.toUpperCase()
                data.passwordSi = dataForm?.passwordNomSi
                data.passwordNo = dataForm?.passwordNomNo
                folioPasswordNom = await dispatch(obtenerFolio(1))
                data.folioPasswordNom = folioPasswordNom.payload.folio
            }
            const dataSolicitudInspeccion = {
                numeroSolicitud: dataForm?.numeroSolicitud,
                telefonoRepresentante: solicitud.telefonorepresentante,
                correoElectronicoRepresentante: solicitud.correoelectronicorepresentante,
                checkFabrica: false,
                checkProductor: false,
                checkNacional: false,
                checkEnvasadora: false,
                checkEnvasador: false,
                checkExportacion: false,
                checkGranel: false,
                checkComercializador: false,
                checkPromocion: false,
                checkProductoTerminado: false,
                checkTraslado: false,
                checkMaduracion: false,
                checkDitamenMarcario: activarCheckMarcario,
                numCertificadoNOM: dataForm?.numCertificadoNOM,
                numeroTraslado: dataForm?.numeroTraslado,
                otrosServicios: dataForm?.otrosServicios,
                fechaInspeccion: dataForm?.fechaInspeccion,
                instalaciones: solicitud.fc_36anexo,
                numeroPlanEvaluacion: dataForm?.numeroPlanEvaluacion,
                inspectorAsignado: dataForm?.inspectorAsignado,
                credencialInspector: dataForm?.credencialInspector,
                telefonoInspector: dataForm?.telefonoInspector,

            }
            data.dataSolicitudInspeccion = dataSolicitudInspeccion
            await dispatch(generarDocumentos(data))
        }

    }
    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = (params) => {
        setOpenModalDevolver(true)
    }
    const handleCloseModalDevolver = () => {
        setOpenModalDevolver(false)

    }
    const modalComponentDevolver = () => {
        return (
            <div>
                <Modal
                    open={openModalDevolver}
                    onClose={handleCloseModalDevolver}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleDevolver}>

                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>¡Advertencia!</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p>Está a punto de devolver esta solicitud.
                                Las observaciones serán enviadas al cliente para correcciones.</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />

                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonDevolverSolicitud() }}>CONTINUAR</button>
                            </div>
                            <div className={` col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDevolver() }}>CANCELAR</button>
                            </div>
                        </div>

                    </Box>
                </Modal>
            </div>
        )
    }
    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {nombresParaPaginas[paginaActiva - 1] === 'Datos generales' ?
                <div className='row justify-content-center'>
                    <div className='col-10'>
                        <TablaAtencionACliente rows={rowspaginaGeneral} api={{ handdleEditPrev }} />
                    </div>
                </div>
                : nombresParaPaginas[paginaActiva - 1] === 'Medios de contacto' ?
                    <div className='row justify-content-center'>
                        <div className='col-10'>
                            <TablaMediosContacto rows={rowspagina1} api={{ handdleEditPrev }} />
                            {solicitud.actualizarmedioscontacto &&
                                <Fragment>
                                    {modoVerDetalle ?
                                        <div className="row text-center">
                                            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                            </div>
                                        </div> :
                                        <div className="row text-center mt-4 mb-4">
                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonAceptarModal} >Aceptar solicitud</button>
                                            </div>
                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                            </div>
                                        </div>}
                                </Fragment>}
                        </div>
                    </div>
                    : nombresParaPaginas[paginaActiva - 1] === 'Persona autorizada' ?
                        <div className='col-10'>
                            <TablaPersonasAutorizadas rows={rowspagina2} api={{ handdleEditPrev }} />
                            {(solicitud.cambiorepresentante && !altaRepresentante) &&
                                <Fragment>
                                    {modoVerDetalle ?
                                        <div className="row text-center">
                                            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                            </div>
                                        </div> :
                                        <div className="row text-center mt-4 mb-4" style={{ marginLeft: '10%' }}>
                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonAceptarModal} >Aceptar solicitud</button>
                                            </div>
                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                            </div>
                                        </div>}
                                </Fragment>}
                        </div>
                        : nombresParaPaginas[paginaActiva - 1] === 'Representante legal y/o Apoderado Legal' ?
                            <div className='col-10'>
                                <TablaRepresentanteslegales rows={rowspagina3} api={{ handdleEditPrev }} />
                                {(solicitud.cambioresponsable && !altaResponsable) &&
                                    <Fragment>
                                        {modoVerDetalle ?
                                            <div className="row text-center">
                                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                                </div>
                                            </div> :
                                            <div className="row text-center mt-4 mb-4" style={{ marginLeft: '10%' }}>
                                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonAceptarModal} >Aceptar solicitud</button>
                                                </div>
                                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                                </div>
                                            </div>}
                                    </Fragment>}
                            </div>
                            : nombresParaPaginas[paginaActiva - 1] === 'Domicilio Fiscal' ?
                                <Fragment>
                                    <div className='row justify-content-center'>
                                        <div className='col-12' style={{ marginLeft: '7%' }}>
                                            <TablaDomicilio rows={rowspaginaDomiclio} api={{ handdleEditPrev }} />
                                            {(solicitud.actualizaciondomicilio && !altaDomicilio) && !solicitud.cambiorazon &&
                                                <Fragment>
                                                    {modoVerDetalle ?
                                                        <div className="row text-center">
                                                            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                                            </div>
                                                        </div> :
                                                        <div className="row text-center mt-4 mb-4">
                                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonAceptarModal} >Aceptar solicitud</button>
                                                            </div>
                                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                                            </div>
                                                        </div>}
                                                </Fragment>}
                                        </div>
                                    </div>
                                </Fragment>
                                : nombresParaPaginas[paginaActiva - 1] === 'Predios/Viveros' ?
                                    <Fragment>
                                        {(solicitud.fc_36_anexoviveros?.filter(anexo => anexo.baja == true).length > 0 ||
                                            solicitud.fc_36_anexoviveros?.filter(anexo => anexo.alta == true).length > 0 ||
                                            (solicitud.cambiorazon && solicitud.viverista)) &&
                                            < Fragment >
                                                <div className='col-md-10' style={{ marginLeft: '11%' }}> <h6 className='text-center labelNaranja'>Viveros</h6></div>
                                                <TablaVivero rows={rowsVivero} api={{ handdleEditPrev }} />
                                            </Fragment>
                                        }
                                        {(solicitud.fc_36_anexopredio?.filter(anexo => anexo.baja == true).length > 0 ||
                                            solicitud.fc_36_anexopredio?.filter(anexo => anexo.alta == true).length > 0 ||
                                            (solicitud.cambiorazon && solicitud.productormaguey)) &&
                                            <Fragment>
                                                <div className='col-md-10' style={{ marginLeft: '11%' }}> <h6 className='text-center labelNaranja'>Predios</h6></div>
                                                <TablaPredio rows={rowsPredio} api={{ handdleEditPrev }} />
                                            </Fragment>
                                        }

                                        {((solicitud.actualizacionprediosviveros && !altaPrediosViveros) ||
                                            (solicitud.actualizacioncadena && (!solicitud.viverista && solicitud.viveristaaltabaja)) ||
                                            (solicitud.actualizacioncadena && (!solicitud.productormaguey && solicitud.productormagueyaltabaja))) && !solicitud.cambiorazon &&
                                            <Fragment>
                                                {modoVerDetalle ?
                                                    <div className="row text-center">
                                                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                                        </div>
                                                    </div> :
                                                    <div className="row text-center mt-4 mb-4">
                                                        <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonAceptarModal} >Aceptar solicitud</button>
                                                        </div>
                                                        <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                                        </div>
                                                    </div>}
                                            </Fragment>}
                                    </Fragment>
                                    : nombresParaPaginas[paginaActiva - 1] === 'Marcas' ?
                                        <Fragment>
                                            {(altaMarcas || (solicitud.cambiorazon && solicitud.comercializadormezcal) || solicitud?.fc_36_anexomarcas?.filter(anexo => anexo.baja == true)?.length > 0) &&
                                                <Fragment>
                                                    <div className='col-md-10' style={{ marginLeft: '10%' }}> <h6 className='text-center labelNaranja'>Marcas de mezcal</h6></div>
                                                    <TablaMarcas rows={rowsMarcas} api={{ handdleEditPrev }} />
                                                </Fragment>
                                            }

                                            {(altaMarcasBebidas || (solicitud.cambiorazon && solicitud.comercializadorbebidas) || solicitud?.fc_36_anexomarcasproductoconmezcal?.filter(anexo => anexo.baja == true).length > 0) &&
                                                <Fragment>
                                                    <div className='col-md-10' style={{ marginLeft: '10%' }}> <h6 className='text-center labelNaranja'>Marcas de productos con mezcal</h6></div>
                                                    <TablaMarcasBebidasConMezcal rows={rowsMarcasBebidas} api={{ handdleEditPrev }} />
                                                </Fragment>
                                            }

                                            {((solicitud.actualizarmarcas && !altaMarcas && !altaMarcasBebidas) ||
                                                (solicitud.actualizacioncadena && (!solicitud.comercializadormezcal && solicitud.comercializadormezcalaltabaja)) ||
                                                (solicitud.actualizacioncadena && (!solicitud.comercializadorbebidas && solicitud.comercializadorbebidasaltabaja))) &&
                                                <Fragment>
                                                    {modoVerDetalle ?
                                                        <div className="row text-center">
                                                            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                                            </div>
                                                        </div> :
                                                        <div className="row text-center mt-4 mb-4" style={{ marginLeft: '10%' }}>
                                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonAceptarModal} >Aceptar solicitud</button>
                                                            </div>
                                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                                            </div>
                                                        </div>}
                                                </Fragment>}
                                        </Fragment>
                                        : nombresParaPaginas[paginaActiva - 1] === 'Actualización Responsables de Instalaciones' ?
                                            <Fragment>
                                                <TablaResponsablesInstalaciones rows={rowsResponsablesInst} api={{ handdleEditPrev }} />
                                                {(solicitud.cambioresponsableinst && !altaResponsableInst) &&
                                                    <Fragment>
                                                        {modoVerDetalle ?
                                                            <div className="row text-center">
                                                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                                                </div>
                                                            </div> :
                                                            <div className="row text-center mt-4 mb-4" style={{ marginLeft: '10%' }}>
                                                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonAceptarModal} >Aceptar solicitud</button>
                                                                </div>
                                                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                                                </div>
                                                            </div>}
                                                    </Fragment>}
                                            </Fragment>
                                            : nombresParaPaginas[paginaActiva - 1] === 'Instalaciones' ?
                                                <Fragment>
                                                    <TablaInstalaciones rows={rowsInstalaciones} api={{ handdleEditPrev }} />
                                                </Fragment>
                                                : nombresParaPaginas[paginaActiva - 1] === 'Documentación' ?
                                                    <Fragment>
                                                        <div className='row justify-content-center'>
                                                            <div className='col-12' style={{ marginLeft: '7%' }}>
                                                                <TablaDocumentacion rows={rowspaginaDoc} api={{ handdleEditPrev }}></TablaDocumentacion>
                                                            </div>
                                                        </div>
                                                        {modoVerDetalle ?
                                                            <div className="row text-center">
                                                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                                                </div>
                                                            </div> :
                                                            <div className="row text-center mt-4 mb-4">
                                                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonAceptarModal} >Aceptar solicitud</button>
                                                                </div>
                                                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                                                </div>
                                                            </div>}
                                                    </Fragment>
                                                    : ''
            } {modalComponentAceptar()}
            {modalComponentDevolver()}
        </Fragment >
    )
}
export default withRouter(FC_36Component)